<template>
   <!-- <loader v-if="showLoader" /> -->
  <div :class="modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3 ResponsiveControlePage'">
    <div class="mb-2" v-if="!modalMode">
      <breadCrumbs
        :routesArray="routesArray"
      ></breadCrumbs>
      <!-- {{ enableApproveAndReject }} -->
    </div>
    <div class="row w-full flex-shrink-0 flex mt-2 justify-between">
        <h1 v-if="!modalMode" class="title truncate min-w-0 max-w-[calc(100%-2.5rem)] pr-4">{{ presentFindingTaskObj.action }}</h1>
        <div v-else></div>
      <!-- <div
        class="flex flex-row"
        v-if="
          !checkreviewer(presentFindingTaskObj.reviewer) &&
          (presentFindingTaskObj.statusCode == 10414 ||
            presentFindingTaskObj.statusCode == 10421 ||
            presentFindingTaskObj.statusCode == 10403)"
      >
        <button
          class="btnprimary items-center btnPrimaryPadding mr-2"
          @click="approveOrReject(10403)"
        >
          Approve
        </button>
        <button
          class="btnprimary items-center btnPrimaryPadding"
          @click="approveOrReject(10410)"
        >
          Reject
        </button>
      </div>
	  <div
        class="flex flex-row"
        v-if="
          checkreviewer(presentFindingTaskObj.reviewer) &&
          (presentFindingTaskObj.statusCode == 10414 ||
            presentFindingTaskObj.statusCode == 10421 ||
            presentFindingTaskObj.statusCode == 10403)"
      >
        <button
          class="btnprimary items-center btnPrimaryPadding mr-2"
          @click="acceptOrReject(10403, 9)"
        >
          Accept
        </button>
        <button
          class="btnprimary items-center btnPrimaryPadding"
          @click="acceptOrReject(10401, 9)"
        >
          Reject
        </button>
      </div> -->
      <!-- for total task approval -->
			<div class="flex flex-row" v-if="(presentFindingTaskObj.reviewer == userInfo._id|| userInfo?.role_id!=10217) && ( presentFindingTaskObj.statusCode == 10421)">
				<button class="btnprimary items-center btnPrimaryPadding mr-2" @click="approveOrRejectForActionTasktoComplete(10403,9)">Approve</button>
				<button class="btnprimary items-center btnPrimaryPadding" @click="onClickToRejectByJustificationAtInReview()">Reject</button>
			</div>

			<!-- for normal approval -->
			<div class="flex flex-row" v-if="presentFindingTaskObj.approvals!= undefined && presentFindingTaskObj.approvals[presentFindingTaskObj.approvals.length - 1].statusCode== 10401 && (presentFindingTaskObj.approvals[presentFindingTaskObj.approvals.length - 1].approver == userInfo._id || userInfo?.role_id!=10217)">
          <button class="btnprimary items-center btnPrimaryPadding mr-2" @click="ApprovalforInprogress(10403)">Approve</button>
          <button class="btnprimary items-center btnPrimaryPadding" @click="clickToRejectByJustification()">Reject</button>
      </div>
    </div>
    <div class="w-full minheight">
        <div class="text-sm">
            <div>
              <div class="mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey flex">
                <Tabs  v-model:value="selectedTabIndex" scrollable class="w-80 heightFixing pr-5">
                  <div>
                    <TabList >
                        <Tab v-for="(tab) in tabHead" :key="tab.id" :value="tab.id" @click="toggleTabs(tab)">
                            {{ tab.displayName }}
                        </Tab>
                    </TabList>
                  </div>
                  <TabPanels class="overflow-auto hide-scrollbar">
                    <TabPanel v-for="(tab) in tabHead" :key="tab.id" :value="tab.id">
                      <div v-if="tabDataLoading == true">
                        <div class="flex items-center justify-center w-full h-16 skeleton">
                          <dots-loader/>
                        </div>
                      </div>
                      <div v-else class="h-full min-h-0">
                        <div class="descriptionToggle overflow-y-auto">
                        <div v-if="tab.id == 1">
                          <div>
                            <div>
                            <div
                              class="border-b border-lightgrey flex justify-between mb-3 paddingBottomForFindings"
                            >
                              <div class="flex items-center justify-center">
                                <div>
                                  <p class="header mt-2.5">Action Information</p>
                                </div>
                              </div>
                            </div>
                          </div>
                          
                           <div class="flex flex-row">
                              <div
                                class="border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md"
                              >
                              Cause
                              </div>
                              <div
                                class="border border-lightgrey w-77 p-2 rounded-tr-md text-xs"
                              >
                                {{ (presentFindingTaskObj.cause != undefined ? presentFindingTaskObj.cause : 'N/A') }}
                                
                              </div>
                            </div>
                            <div class="flex flex-row">
                              <div
                                class="border-l border-b p-2 header w-23 border-lightgrey"
                              >
                              Action
                                
                              </div>
                              <div
                                class="border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify"
                              >
                              {{ (presentFindingTaskObj.action != undefined ? presentFindingTaskObj.action : 'N/A')}}
                              </div>
                            </div>
                            <div>
                            <div
                              class="border-b border-lightgrey flex justify-between mb-3 paddingBottomForFindings"
                            >
                              <div class="flex items-center justify-center">
                                <div>
                                  <p class="header mt-2.5">Finding Information</p>
                                </div>
                              </div>
                            </div>
                          </div>
                            <!-- <div class="flex flex-row">
                              <div
                                class="border-t border-l border-b p-2 header w-23 border-lightgrey rounded-tl-md"
                              >
                                Finding ID
                              </div>
                              <div
                                class="border border-lightgrey w-77 p-2 rounded-tr-md text-xs"
                              >
                                {{ String(findingDetails[0].id).toUpperCase()||'N/A'}}
                              </div>
                            </div> -->
                             <div class="flex flex-row">
                              <div
                                class="border-t border-l border-b p-2 header w-1/4 border-lightgrey rounded-tl-md"
                              >
                                Finding ID
                              </div>
                              <div
                                class="border-t border-b border-l p-2 header borderwidth w-1/3 border-lightgrey text-sm"
                              >
                                {{ String(findingDetails[0].id).toUpperCase()||'N/A'}}
                              </div>
                                <div
                                  class="border-t border-b border-l p-2 header w-1/4 border-lightgrey"
                                >
                                  CR ID
                                </div>
                                <div
                                  class="border p-2 header w-1/4 border-lightgrey rounded-tr-md text-sm"
                                >
                                  {{ String(presentFindingTaskObj.complianceReviewId).toUpperCase() }}
                                </div>
                            </div>
                            <div class="flex flex-row">
                              <div
                                class="border-l border-b p-2 header w-1/4 border-lightgrey"
                              >
                                {{ getFindingRelatedToFieldLabel(findingDetails[0]) }}
                              </div>
                              <div
                                class="border-b border-l p-2 borderwidth w-1/3 border-lightgrey text-xs"
                              >
                                {{ getFindingRelatedToDisplay(findingDetails[0]) }}
                              </div>
                              <div
                                class="border-b border-l p-2 header w-1/4 border-lightgrey"
                              >
                                {{ getFindingLinkFieldLabel(findingDetails[0]) }}
                              </div>
                              <div
                                class="border-r border-b border-l border-lightgrey w-1/4 text-xs p-2"
                              >
                                {{ getFindingLinkDisplay(findingDetails[0]) }}
                              </div>
                            </div>
                            <div class="flex flex-row">
                              <div
                                class="border-l border-b p-2 header w-23 border-lightgrey"
                              >
                                Finding
                              </div>
                              <div
                                class="border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify"
                              >
                                {{ findingDetails[0].name||'N/A'}}
                              </div>
                            </div>
                            <div class="flex flex-row">
															<div
																class="border-l border-b p-2 header w-23 border-lightgrey flex items-center"
															>
																Evidence
															</div>
															<div
																class="border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify"
															>
																<div v-if="findingDetailFileEvidences.length || findingDetailLinkEvidences.length" class="flex gap-3 flex-wrap">
																<div v-for="(doc, idx) in findingDetailFileEvidences" :key="'finding-detail-file-'+idx">
																	<div class="pdf w-full rounded-sm">
                                    <a
                                      href="#"
                                      @click.prevent="openEvidenceFile(doc)"
                                      class="flex w-full flex-row items-center cursor-pointer"
                                    >
																			<img src="@/assets/doc.svg" alt="" v-if=" getEvidenceFileExt(doc)=='doc'"/>
																			<img src="@/assets/docx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='docx'" />
																			<img src="@/assets/xls.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xls'" />
																			<img src="@/assets/xlsx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xlsx'" />
																			<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='rtf'"/>
																			<img src="@/assets/txt.svg" alt="" v-if=" getEvidenceFileExt(doc)=='txt'"/>
																			<img src="@/assets/png.svg" alt="" v-if=" getEvidenceFileExt(doc)=='png'"/>
																			<img src="@/assets/jpg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpg'"/>
																			<img src="@/assets/jpeg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpeg'"/>
																			<img src="@/assets/csv.svg" alt="" v-if=" getEvidenceFileExt(doc)=='csv'"/>
																			<img src="@/assets/zip.svg" alt="" v-if=" getEvidenceFileExt(doc)=='zip'"/>
																			<img src="@/assets/mp4.svg" alt="" v-if=" getEvidenceFileExt(doc)=='mp4'"/>
																			<img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='pdf'" />
																			<div class="flex flex-col w-full min-w-0">
																				<div class="ml-2 pb-1">
																				<p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
																				</div>
																				<div class="flex justify-between w-full">
																				<p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
																				<p class="mr-2 fontSize10PX font-semibold">{{ doc.linkedEvidenceTaskId ? (presentFindingTaskObj.taskId || 'N/A') : (doc.taskId ? doc.taskId : 'N/A') }}</p>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
																<div v-for="(doc, idx) in findingDetailLinkEvidences" :key="'finding-detail-link-'+idx">
																	<div class="pdf w-full rounded-sm flex flex-row items-center">
                                    <a
                                      href="#"
                                      @click.prevent="openEvidenceFile(doc)"
                                      class="finding-evidence-link-icon cursor-pointer"
                                      :aria-label="doc.url"
                                    >
																			<span class="finding-evidence-link-icon__img-wrap">
																				<img src="@/assets/link.svg" alt="Link" class="finding-evidence-link-icon__img" />
																				<span class="finding-evidence-link-icon__tooltip">{{ doc.url }}</span>
																			</span>
																		</a>
																			<div class="flex flex-col w-full min-w-0">
																				<div class="ml-2 pb-1">
																				<p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
																				</div>
																				<div class="flex justify-between w-full">
																				<p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
																				<p class="mr-2 fontSize10PX font-semibold">{{ doc.linkedEvidenceTaskId ? (presentFindingTaskObj.taskId || 'N/A') : (doc.taskId ? doc.taskId : 'N/A') }}</p>
																				</div>
																			</div>
																	</div>
																</div>
																</div>
																<div v-else>N/A</div>
															</div>
															
														</div>
                            <div class="flex flex-row">
                              <div
                                class="border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md flex items-center"
                              >
                                Finding Severity
                              </div>
                              <div
                                class="border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify rounded-br-md flex items-center"
                              >
                                <div
                                  v-if="getFindingSeverityValue(findingDetails[0]) != null"
                                  class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden"
                                  :class="findingSeverityChipBg(findingDetails[0])"
                                  :title="getFindingSeverityLabel(findingDetails[0])"
                                >
                                  <div class="truncate whitespace-nowrap" :class="findingSeverityChipText(findingDetails[0])">
                                    {{ getFindingSeverityLabel(findingDetails[0]) }}
                                  </div>
                                </div>
                                <span v-else>N/A</span>
                              </div>
                            </div>
                            
                             <div v-if="presentFindingTaskObj.appId!=undefined && presentFindingTaskObj?.appId==10003">
                                <div>
                                    <div>
                                      <div class="border-b border-lightgrey">
                                          <p class="mt-4 mb-1.5 header">Risk Information</p>
                                      </div>
                                    </div>
                                    <div class="flex mb-1">
                                      <div class="w-6/12">
                                        <p class="font-extrabold mt-3 mb-1 text-xs">Risk</p>
                                        <p v-if="(presentFindingTaskObj?.risk||'N/A')" class="mt-1 text-sm">{{ presentFindingTaskObj?.risk ||'N/A'}}</p>
                                        <p v-else class="text-sm mt-1">N/A</p>
                                      </div>
                                      <div class="w-6/12">
                                        <p class="font-extrabold mt-3 mb-1 text-xs">Priority</p>
                                        <div v-if="presentFindingTaskObj?.priority && typeof presentFindingTaskObj?.priority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="colorLabelBg(presentFindingTaskObj?.priority)">
                                          <div class="text-xs" :class="colorLabelText(presentFindingTaskObj?.priority)">
                                          {{ getProirityLabel(presentFindingTaskObj?.priority) }}
                                          </div>
                                        </div>
                                        <div v-else class="text-sm mt-2">N/A</div>

                                      </div>
                                      
                                    </div>

                                    <div class="flex mb-1">
                                      <!-- <div class="w-6/12">
                                        <p class="font-extrabold mb-1 text-xs">Action</p>
                                        <p v-if="(riskInformationArray.riskInformation.action)" class="mt-1 text-sm">{{riskInformationArray.riskInformation.action||'N/A' }}</p>
                                        <p v-else class="text-sm mt-1">N/A</p>
                                      </div> -->
                                      <div class="w-6/12">
                                        <p class="font-extrabold mb-1 text-xs">Risk Category</p>
                                        <p v-if="(presentFindingTaskObj?.riskCategory)" class="mt-1 text-sm">{{ presentFindingTaskObj?.riskCategory||'N/A' }}</p>
                                        <p v-else class="text-sm mt-1">N/A</p>
                                      </div>
                                      <div class="w-6/12">
                                        <p class="font-extrabold mb-1 text-xs">Risk Owner</p>
                                        <p v-if="(presentFindingTaskObj?.riskOwner)" class="mt-1 text-sm">{{ getRiskOwnerLabel(presentFindingTaskObj?.riskOwner)||'N/A' }}</p>
                                        <p v-else class="text-sm mt-1">N/A</p>
                                      </div>
                                      
                                    </div>
                                    <div class="flex mb-1">
                                      <div class="w-6/12">
                                        <p class="font-extrabold mt-2 mb-1 text-xs">Threat Category</p>
                                        <p v-if="(presentFindingTaskObj?.threatCategory)" class="mt-1 mb-3 text-sm">{{ presentFindingTaskObj?.threatCategory||'N/A' }}</p>
                                        <p v-else class="text-sm mt-1 mb-3">N/A</p>
                                      </div>
                                      <div class="w-6/12"> 
                                        <label class="font-extrabold mt-2 mb-1 text-xs">Threat Source</label>
                                        <p v-if="(presentFindingTaskObj?.threatSource)" class="mt-1 mb-3 text-sm">{{ presentFindingTaskObj?.threatSource||'N/A' }}</p>
                                        <p v-else class="text-sm mt-1 mb-3">N/A</p>
                                      </div>
                                      

                                    </div>
                                    <div class="w-full">
                                        <p class="font-extrabold mt-2 mb-1 text-xs">Threat</p>
                                        <p v-if="(presentFindingTaskObj?.threatEvent)" class="mt-1 mb-3 text-sm">{{ presentFindingTaskObj?.threatEvent||'N/A' }}</p>
                                        <p v-else class="text-sm mt-1 mb-3">N/A</p>
                                      </div>
                                    <div class="w-full"> 
                                      <label class="font-extrabold mt-2 text-xs">Vulnerability</label>
                                      <p v-if="(presentFindingTaskObj?.vulnerability)" class="mt-1 mb-3 text-sm">{{ presentFindingTaskObj?.vulnerability||'N/A' }}</p>
                                      <p v-else class="text-sm mt-1 mb-3">N/A</p>
                                    </div>
                                    <div class="w-full">
                                      <p class="font-extrabold mb-2 text-xs">Risk Assessment</p>
                                      <p v-if="(presentFindingTaskObj?.riskAssessment!='')" class="mt-1 mb-3 text-sm">{{ presentFindingTaskObj?.riskAssessment||'N/A' }}</p>
                                      <p v-else class="text-sm mt-1 mb-3">N/A</p>
                                    </div>
                                    <div class="w-full">
                                      <p class="font-extrabold mb-1 text-xs">Treatment Summary</p>
                                      <p v-if="(presentFindingTaskObj?.treatmentType!='')" class="mt-1 text-sm">{{ treatmentSummaryData(presentFindingTaskObj?.treatmentType)||'N/A' }}</p>
                                      <p v-else class="text-sm mt-1">N/A</p>
                                    </div>
                                    </div>
												<div>
												<h1 class="upperspacing">Inherited Risk</h1>
												<!-- </div> -->
												<div class="border-b pt-1 border-solid border-lightgrey"></div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Strategic</label>
															 <div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.business)">
																<div :class="colorLabel(presentFindingTaskObj?.business)">
																	{{getLablesInfo(presentFindingTaskObj?.business,1)||'N/A'}}
																</div>
															</div>
															
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Financial</label>
															 <div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.financial)">
																<div :class="colorLabel(presentFindingTaskObj?.financial)">
																	{{getLablesInfo(presentFindingTaskObj?.financial,2)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Operations</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.operations)">
																<div :class="colorLabel(presentFindingTaskObj?.operations)">
																	{{getLablesInfo(presentFindingTaskObj?.operations,3)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Compliance</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.legal)">
																<div :class="colorLabel(presentFindingTaskObj?.legal)">
																	{{getLablesInfo(presentFindingTaskObj?.legal,4)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="formcontainer upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-3/6">
															<label class="controllabel">Likelihood</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.likelihood)">
																<div :class="colorLabel(presentFindingTaskObj?.likelihood)">
																	{{getLablesInfo(presentFindingTaskObj?.likelihood,5)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-3/6 leftspacing">
															<label class="controllabel">Overall Impact</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.overallImpact)">
																<div :class="colorLabel(presentFindingTaskObj?.overallImpact)">
																	{{getLablesInfo(presentFindingTaskObj?.overallImpact,6)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												</div>
												<div v-if="presentFindingTaskObj?.treatmentType && presentFindingTaskObj?.treatmentType!=10419">
													<h1 class="upperspacing">Residual Risk</h1>
												<!-- </div> -->
												<div class="border-b pt-1 border-solid border-lightgrey"></div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Strategic</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.residual?.[0]?.business)">
																<div :class="colorLabel(presentFindingTaskObj?.residual?.[0]?.business)">
																	{{getLablesInfo(presentFindingTaskObj?.residual?.[0]?.business,1)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Financial</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.residual?.[0]?.financial)">
																<div :class="colorLabel(presentFindingTaskObj?.residual?.[0]?.financial)">
																	{{getLablesInfo(presentFindingTaskObj?.residual?.[0]?.financial,2)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Operations</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.residual?.[0]?.operations)">
																<div :class="colorLabel(presentFindingTaskObj?.residual?.[0]?.operations)">
																	{{getLablesInfo(presentFindingTaskObj?.residual?.[0]?.operations,3)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Compliance</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.residual?.[0]?.legal)">
																<div :class="colorLabel(presentFindingTaskObj?.residual?.[0]?.legal)">
																	{{getLablesInfo(presentFindingTaskObj?.residual?.[0]?.legal,4)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="formcontainer upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-3/6">
															<label class="controllabel">Likelihood</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.residual?.[0]?.likelihood)">
																<div :class="colorLabel(presentFindingTaskObj?.residual?.[0]?.likelihood)">
																	{{getLablesInfo(presentFindingTaskObj?.residual?.[0]?.likelihood,5)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-3/6 leftspacing">
															<label class="controllabel">Overall Impact</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingTaskObj?.overallImpact)">
																<div :class="colorLabel(presentFindingTaskObj?.overallImpact)">
																	{{getLablesInfo(presentFindingTaskObj?.overallImpact,6)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												</div>
                    </div>
                          </div>
                          
                        </div>  
                          <div v-if="tab.id == 2">
                            <div>
                              <div
                              >
                              <div
                                class="border-b border-lightgrey flex justify-between mb-3 paddingBottomForFindings"
                              >
                                <div class="flex items-center justify-center">
                                  <div>
                                    <p class="header mt-2.5">Documents which are related to the controls</p>
                                  </div>
                                </div>
                              </div>
                              </div>
                              <!-- <p class="mt-1.5">{{ descriptionObject._id }}</p> -->
                            </div>
                          </div>
                          <div  v-if="tab.id == 3">
                            <div class="evidence-tab-content">
                              <div class="evidence-files-block">
                              <div
                                class="border-b border-lightgrey flex justify-between paddingAdjustment mb-5 mt-2"
                              >
                                <div class="flex items-center justify-center">
                                  <div>
                                    <p class="header">Files</p>
                                  </div>
                                </div>
                                <div>
                                  <div
                                    class="buttonposition flex justify-center items-center"
                                  >
                                    <div
                                      class="buttonposition flex justify-center items-center"
                                    >
                                    <button
                                      @click="openLinkEvidencePopup"
                                      :class="isEvidenceAttachDisabled() ? 'btndisabled borderForBtndisabled pointer-events-none mr-3' : 'filterButton flex justify-center mr-3'"
                                      class="flex justify-center"
                                    >
                                      Link Existing
                                    </button>
                                    <button
                                      @click="openFilePopup('file')"
                                      for="upload"
                                      :class="
                                        TaskDetailsDropDown.taskStatus == 10403 ||
                                        TaskDetailsDropDown.taskStatus == 10417 ||
                                        presentComplianceObject.statusCode == 10403 || TaskDetailsDropDown.taskStatus == 10418 ||
                                        presentComplianceObject.statusCode == 10418 || presentFindingTaskObj.reviewer == userInfo._id && (userInfo?.role_id==10215 && userInfo?.roleId==10215) || !isAddDisabled(10302)
                                          ? 'btndisabled borderForBtndisabled pointer-events-none'
                                          : 'filterButton flex justify-center'
                                      "
                                      class="flex justify-center"
                                    >
                                      Attach
                                    </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="evidence-files-section">
                              <div
                                v-if="fileEvidences.length"
                                class="flex mt-4 gap-4 flex-wrap"
                              >
                                <div
                                  v-for="(doc, idx) in fileEvidences"
                                  :key="'file-'+idx"
                                >
                                  <div class="pdf w-full rounded-sm">
                                    <a
                                      href="#"
                                      @click.prevent="openEvidenceFile(doc)"
                                      class="flex w-full flex-row items-center cursor-pointer"
                                    >
                                            <img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='pdf'"  />
                                            <img src="@/assets/doc.svg" alt="" v-if=" getEvidenceFileExt(doc)=='doc'" />
                                            <img src="@/assets/docx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='docx'"  />
                                            <img src="@/assets/xls.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xls'"  />
                                            <img src="@/assets/xlsx.svg" alt="" v-if=" getEvidenceFileExt(doc)=='xlsx'"  />
                                            <img src="@/assets/pdf.svg" alt="" v-if=" getEvidenceFileExt(doc)=='rtf'" />
                                            <img src="@/assets/txt.svg" alt="" v-if=" getEvidenceFileExt(doc)=='txt'" />
                                            <img src="@/assets/png.svg" alt="" v-if=" getEvidenceFileExt(doc)=='png'" />
                                            <img src="@/assets/jpg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpg'" />
                                            <img src="@/assets/jpeg.svg" alt="" v-if=" getEvidenceFileExt(doc)=='jpeg'" />
                                            <img src="@/assets/csv.svg" alt="" v-if=" getEvidenceFileExt(doc)=='csv'" />
                                            <img src="@/assets/zip.svg" alt="" v-if=" getEvidenceFileExt(doc)=='zip'" />
                                            <img src="@/assets/mp4.svg" alt="" v-if=" getEvidenceFileExt(doc)=='mp4'" />
                                      <div class="flex flex-col w-full min-w-0">
                                        <div class="ml-2 pb-1">
                                          <p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
                                        </div>
                                        <div class="flex justify-between w-full">
                                          <p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
                                          <p class="mr-2 fontSize10PX font-semibold">{{ doc.linkedEvidenceTaskId ? (presentFindingTaskObj.taskId || 'N/A') : (doc.taskId ? doc.taskId : 'N/A') }}</p>
                                        </div>
                                      </div>
                                      <button v-if="!isPlannerCreatedEvidence(doc)" type="button" class="evidence-file-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentFindingTaskObj.files.indexOf(doc))" :class="isEvidenceAttachDisabled() ? 'pointer-events-none' : ''">
                                        <img src="@/assets/deleteIcon.svg" alt="Delete" />
                                      </button>
                                    </a>
                                  </div>
                                </div>
                              </div>
                              <p v-else class="text-xs text-placeholdergray mt-3">No files attached</p>
                              </div>
                              </div>

                              <div class="evidence-links-section">
                              <div class="border-b border-lightgrey flex justify-between paddingAdjustment mt-6">
                                <div class="flex items-center justify-center">
                                  <p class="header">Links</p>
                                </div>
                                <div class="buttonposition flex justify-center items-center">
                                  <button
                                    @click="openFilePopup('url')"
                                    :class="
                                      TaskDetailsDropDown.taskStatus == 10403 ||
                                      TaskDetailsDropDown.taskStatus == 10417 ||
                                      presentComplianceObject.statusCode == 10403 || TaskDetailsDropDown.taskStatus == 10418 ||
                                      presentComplianceObject.statusCode == 10418 || presentFindingTaskObj.reviewer == userInfo._id && (userInfo?.role_id==10215 && userInfo?.roleId==10215) || !isAddDisabled(10302)
                                        ? 'btndisabled borderForBtndisabled pointer-events-none'
                                        : 'filterButton flex justify-center'
                                    "
                                    class="flex justify-center"
                                  >
                                    Add Link
                                  </button>
                                </div>
                              </div>
                              <div class="evidence-links-wrap" :class="{ 'evidence-links-wrap--empty': filteredLinkCount === 0 }">
                                <div class="evidence-links-scroll">
                                  <div class="evidence-links-header">
                                    <table class="evidence-links-table" :style="linkTableResizeStyle">
                                      <thead>
                                        <tr>
                                          <th class="cursor-pointer evidence-links-col-id resizable-th" :style="linkColumnStyle('taskId')" @click="onLinkHeaderClick('taskId')">
                                            <div class="flex items-center">
                                              <div>ID</div>
                                              <div class="sort cursor-pointer" :class="linkSortKey === 'taskId' ? linkSortClass : 'opacity-50'"></div>
                                            </div>
                                            <span class="column-resize-handle" @mousedown.stop.prevent="startLinkColumnResize($event, 'taskId')"></span>
                                          </th>
                                          <th class="cursor-pointer evidence-links-col-title resizable-th" :style="linkColumnStyle('filename')" @click="onLinkHeaderClick('filename')">
                                            <div class="flex items-center">
                                              <div>Link Title</div>
                                              <div class="sort cursor-pointer" :class="linkSortKey === 'filename' ? linkSortClass : 'opacity-50'"></div>
                                            </div>
                                            <span class="column-resize-handle" @mousedown.stop.prevent="startLinkColumnResize($event, 'filename')"></span>
                                          </th>
                                          <th class="cursor-pointer evidence-links-col-link resizable-th" :style="linkColumnStyle('url')" @click="onLinkHeaderClick('url')">
                                            <div class="flex items-center">
                                              <div>Link</div>
                                              <div class="sort cursor-pointer" :class="linkSortKey === 'url' ? linkSortClass : 'opacity-50'"></div>
                                            </div>
                                            <span class="column-resize-handle" @mousedown.stop.prevent="startLinkColumnResize($event, 'url')"></span>
                                          </th>
                                          <th class="cursor-pointer evidence-links-col-date resizable-th" :style="linkColumnStyle('evidenceDate')" @click="onLinkHeaderClick('evidenceDate')">
                                            <div class="flex items-center">
                                              <div>Evidence Date</div>
                                              <div class="sort cursor-pointer" :class="linkSortKey === 'evidenceDate' ? linkSortClass : 'opacity-50'"></div>
                                            </div>
                                            <span class="column-resize-handle" @mousedown.stop.prevent="startLinkColumnResize($event, 'evidenceDate')"></span>
                                          </th>
                                          <th class="evidence-links-col-action"></th>
                                        </tr>
                                      </thead>
                                    </table>
                                  </div>
                                  <div class="evidence-links-body">
                                    <table class="evidence-links-table" :style="linkTableResizeStyle">
                                      <tbody v-if="paginatedLinkEvidences.length">
                                        <tr
                                          v-for="(doc, idx) in paginatedLinkEvidences"
                                          :key="'link-'+idx"
                                          class="rowHeight evidence-links-row"
                                        >
                                          <td class="evidence-links-col-id" :style="linkColumnStyle('taskId')" :title="doc.linkedEvidenceTaskId ? (presentFindingTaskObj.taskId || 'N/A') : (doc.taskId || 'N/A')">
                                            <div class="table-ellipsis">{{ doc.linkedEvidenceTaskId ? (presentFindingTaskObj.taskId || 'N/A') : (doc.taskId || 'N/A') }}</div>
                                          </td>
                                          <td class="evidence-links-col-title" :style="linkColumnStyle('filename')" :title="doc.filename || doc.name">
                                            <div class="table-ellipsis">{{ doc.filename || doc.name || 'N/A' }}</div>
                                          </td>
                                          <td class="evidence-links-col-link" :style="linkColumnStyle('url')">
                                            <div class="table-ellipsis">
                                              <a href="#" class="text-primary evidence-link-anchor cursor-pointer" @click.prevent="openEvidenceFile(doc)" :title="doc.url">{{ doc.url }}</a>
                                            </div>
                                          </td>
                                          <td class="evidence-links-col-date" :style="linkColumnStyle('evidenceDate')">{{ doc.evidenceDate ? formatFileAttachedTime(doc.evidenceDate) : 'N/A' }}</td>
                                          <td class="evidence-links-col-action">
                                            <button v-if="!isPlannerCreatedEvidence(doc)" type="button" class="evidence-links-delete" @click.stop.prevent="openDeleteEvidenceConfirm(presentFindingTaskObj.files.indexOf(doc))" :class="isEvidenceAttachDisabled() ? 'pointer-events-none' : ''">
                                              <img src="@/assets/deleteIcon.svg" alt="Delete" class="h-5 w-5" />
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                      <tbody v-else>
                                        <tr>
                                          <td class="evidence-links-empty" colspan="5">
                                            <div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                                <pagination
                                  v-if="filteredLinkCount > 0"
                                  :dynamicPagination="filteredLinkCount"
                                  :sortedData="sortedLinkEvidences"
                                  @currentPageUpdate="onLinkPaginationUpdate"
                                />
                              </div>
                              </div>
                            </div>
                          </div>
                          <div  v-if="tab.id == 4">
                            <div class="border-b border-lightgrey flex justify-between paddingAdjustment mb-5 mt-2">
                                  <div class="flex items-center justify-center">
                                    <div>
                                      <p class="header">Comments</p>
                                    </div>
                                  </div>
                                  <div>
                                    <div
                                      class="buttonposition flex justify-center items-center"
                                    >
                                      <div
                                        class="buttonposition flex justify-center items-center"
                                      >
                                      <button
                                          class="filterButton flex"
                                          v-if="oldComments"
                                          @click="sortComments()"
                                          :class="Object.keys(this.presentFindingTaskObj).includes('comments') && this.presentFindingTaskObj.comments.length != 0 ? 'filterButton' : 'pointer-events-none'"
                                        >
                                          <img
                                            src="@/assets/sortBy.svg"
                                            class="h-3 mr-2.5"
                                          />
                                          Oldest
                                        </button>
                                        <button
                                          class="filterButton flex"
                                          v-if="!oldComments"
                                          @click="sortComments()"
                                        >
                                          <img
                                            src="@/assets/sortBy.svg"
                                            class="h-3 mr-2.5 rotate-180"
                                          />
                                          Newest
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                            </div>
                            <div>
                              <div class="comment-box w-full">
                                  <div class="my-3">
                                      <commentsEditor v-if="TaskDetailsDropDown.taskStatus!=10403 && TaskDetailsDropDown.taskStatus!=10418 && TaskDetailsDropDown.taskStatus!=10417 &&isAddDisabled(10302)" :taskStatusCode="TaskDetailsDropDown.taskStatus"/>
                                    </div>
                              </div>
                              <div v-if="Object.keys(presentFindingTaskObj).includes('comments')" class="comments">
                                  <div v-for="(obj, index) in presentFindingTaskObj.comments" class="border border-lightgrey mt-2 rounded-sm flex flex-row p-2" :key="index">
                                     <div v-if="Object.keys(obj).includes('createdBy')" class="initials">
                                        {{ extractInitials(obj.name) }}
                                      </div>
                                      <div v-if="Object.keys(obj).includes('updatedBy')" class="initials">
                                        {{ extractInitials(obj.name) }}
                                      </div>
                                      <div class="w-1/5">
                                          <div class="header">{{ obj.name }}</div>
                                          <div class="fontSize10PX">{{ obj.createdAt }}</div>
                                      </div>
                                      <!-- <div class="w-4/5 text-xs">{{ obj.comment }}</div> -->
                                      <!-- <div class="w-4/5 text-xs" v-html="obj.comment"></div> -->
                                      <div class="w-4/5 text-xs">
                                        <safeHtml :content="obj.comment"/>
                                      </div>
                                  </div>
                              </div>
                              <!-- <div v-if="Object.keys(presentFindingTaskObj).includes('comments')" class="comments">
                                <div
                                  v-for="(obj, index) in presentFindingTaskObj.comments"
                                  class="border border-lightgrey mt-2 rounded-sm flex flex-row p-2"
                                  :key="index"
                                >
                                  <div class="w-1/5 mr-5">
                                    <div class="header">
                                      {{ getPersonName(obj.createdBy) }}
                                    </div>
                                    <div class="fontSize10PX">{{ obj.createdAt }}</div>
                                  </div>
                                  <div class="w-4/5 text-xs">
                                    <safeHtml :content="obj.comment"/>
                                  </div>
                                </div>
                              </div> -->
                            </div>
                          </div>
                          <div  v-if="tab.id == 5">
                            <div>
                              <div
                                class="border-b border-lightgrey flex justify-between paddingAdjustment mt-2"
                              >
                                <div class="flex items-center justify-center">
                                  <div>
                                    <p class="header">Approvals</p>
                                  </div>
                                </div>
                                <div>
                                  <div
                                    class="buttonposition flex justify-center items-center"
                                  >
                                    <div
                                      class="buttonposition flex justify-center items-center"
                                    >
                                    <!-- {{userInfo._id}} ==
                                    {{presentFindingTaskObj.teamOwner}} ---


                                    {{approvalObj.statusCode}} ''''''''
                                    {{TaskDetailsDropDown.taskStatus}}
                                    {{presentFindingTaskObj.teamOwner == userInfo._id}}
                                    {{presentFindingTaskObj.assignee != undefined && presentFindingTaskObj.assignee.value == userInfo._id}}
                                    -----
                                    {{TaskDetailsDropDown.taskStatus ==10414 || approvalObj.statusCode == 10401 || presentFindingTaskObj.statusCode == 10403 || (presentFindingTaskObj.teamOwner != userInfo._id || presentFindingTaskObj.assignee.value != userInfo._id)}} -->
                                    <button @click="openApprovalpopup()" :class="(newAssignee.value != userInfo._id  && presentFindingTaskObj.teamOwner != userInfo._id && userInfo?.role_id==10217) || TaskDetailsDropDown.taskStatus == 10418 || TaskDetailsDropDown.taskStatus ==10414 || approvalObj.statusCode == 10401 || presentFindingTaskObj.statusCode == 10403 || (presentFindingTaskObj.teamOwner != userInfo._id &&( presentFindingTaskObj.assignee != undefined && (presentFindingTaskObj.assignee.value != userInfo._id && userInfo?.role_id==10217))) || !isAddDisabled(10302) ?'btndisabled pointer-events-none' : 'filterButton flex justify-center'" class=" flex justify-center ">Send Approval</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div v-for="(approval, number) in presentFindingTaskObj.approvals" :key="number" class="bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full">
                                  <div v-if="approval.createdBy != undefined" class="initials">{{extractInitials(approval.name)}}</div>
                                  <div v-if="approval.createdBy != undefined" class="font-semibold mt-1 text-xs">{{ approval.name }}</div>
                                  <div v-if="approval.updatedBy != undefined" class="initials">{{extractInitials(approval.name)}}</div>
                                  <div v-if="approval.updatedBy != undefined" class="font-semibold mt-1 text-xs">{{ approval.name }}</div>
                                  <div v-if="approval.statusCode == 10401" class="mx-2 mt-1 text-xs"> {{' Requested an approval '}} </div>
                                  <div v-if="approval.statusCode == 10410" class="mx-2 mt-1 text-xs"> {{' Rejected an approval '}} </div>
                                  <div v-else-if="approval.statusCode == 10403" class="mx-2 mt-1 text-xs"> {{' Approved an approval '}} </div>
                                  <div  v-if="approval.createdAt != undefined" class="font-semibold mt-1 text-xs">{{approval.createdAt}}</div>
                                  <div  v-if="approval.updatedAt != undefined" class="font-semibold mt-1 text-xs">{{approval.updatedAt}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="tab.id == 6"> 
                            <div>
                              <div
                                class="border-b border-lightgrey flex justify-between paddingAdjustment mt-2"
                              >
                                <div class="flex items-center justify-center">
                                  <div>
                                    <p class="header">History</p>
                                  </div>
                                </div>
                                <div>
                                  <div
                                    class="buttonposition flex justify-center items-center"
                                  >
                                    <div
                                      class="buttonposition flex justify-center items-center"
                                    >
                                    <button class="filterButton flex" v-if="newHistory" @click="sortWorkLog()" :class="Object.keys(this.workLogObject).includes('taskHistory') && this.workLogObject.taskHistory.length != 0 ? 'filterButton' : ' pointer-events-none'">
                                        <img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
                                        Oldest
                                      </button>
                                      <button class="filterButton flex" v-if="!newHistory" @click="sortWorkLog()">
                                        <img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
                                        Newest
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                                <div>

                                  <div v-for="work in workLogObject.taskHistory" :key="work" class="bg-white py-4 mb-0.5 border-lightgrey border-b w-full">
                                    <div class="flex">
                                      <div v-if="checkKey(work,'createdBy')" class="initials">
                                        {{ extractInitials(work.name) }}
                                      </div>
                                      <div v-if="Object.keys(work).includes('updatedBy')" class="initials">
                                        {{ extractInitials(work.name) }}
                                      </div>
                                      <div class="logContainer w-93">
                                        <div class="flex mt-1">
                                          <p v-if="Object.keys(work).includes('createdBy')" class="font-semibold mt-1 text-xs">
                                            {{ work.name }}
                                          </p>
                                          <p v-else-if="Object.keys(work).includes('updatedBy')" class="font-semibold mt-1 text-xs">
                                            {{work.name }}
                                          </p>

                                          <p v-if="work.actionEntity == 10301" class="mx-2 mt-1 text-xs">{{ 'Created the Task on' }}</p>
                                          <p v-else-if="work.statusCode != undefined && work.statusCode == 10418" class="mx-2 mt-1 text-xs">{{ 'Terminated the Task on' }}</p>
                                          <p v-else-if="work.actionEntity == 10302" class="mx-2 mt-1 text-xs">{{ 'Updated the Task on' }}</p>

                                          <p v-if="Object.keys(work).includes('createdAt')" class="font-semibold mt-1 text-xs">{{ formatTime(work.createdAt) }}</p>
                                          <p v-if="Object.keys(work).includes('updatedAt')" class="font-semibold mt-1 text-xs">{{ formatTime(work.updatedAt) }}</p>
                                        </div>
                                        
                                        <div class="mt-3" v-if="Object.keys(work).includes('additionalInfo')">
                                          
                                            <div v-if="work.additionalInfo">
                                              <div v-if="checkKey(work.additionalInfo,'comment')" class="flex">
                                                <div class="font-semibold text-xs">Comment:</div>
                                                <div class="text-xs">
                                                    <safeHtml :content="work.additionalInfo.comment"/>
                                                </div>
                                              </div>
                                            <div class="flex" v-if="Object.keys(work.additionalInfo).includes('evidence') && !work.additionalInfo.removed">
                                              <p class="font-semibold text-xs">{{'Uploaded the Evidence -'}}</p>
                                              <p class="mx-2 text-xs">{{ work.additionalInfo.evidence }}</p>
                                            </div>
                                            <div class="flex" v-if="work.additionalInfo.removed">
                                              <p class="font-semibold text-xs">{{'Deleted the Evidence -'}}</p>
                                              <p class="mx-2 text-xs">{{ work.additionalInfo.evidence }}</p>
                                            </div>
                                            <div class="flex" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceTitles')">
                                              <p class="font-semibold text-xs">{{'Linked the Evidence -'}}</p>
                                              <p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceTitles }}</p>
                                            </div>
                                            <div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('linkedEvidenceDates')">
                                              <p class="font-semibold text-xs">{{'Linked Evidence Date -'}}</p>
                                              <p class="mx-2 text-xs">{{ work.additionalInfo.linkedEvidenceDates }}</p>
                                            </div>
                                            <div class="flex mt-2" v-if="Object.keys(work.additionalInfo).includes('evidenceDate')">
                                              <p class="font-semibold text-xs">{{'Evidence Date -'}}</p>
                                              <p class="mx-2 text-xs">{{ formatDate(work.additionalInfo.evidenceDate)||'N/A' }}</p>
                                            </div>
                                            <div class="flex" v-if="Object.keys(work.additionalInfo).includes('assignee')">
                                              <p class="font-semibold text-xs">{{'Assigned the Task To -'}}</p>
                                              <p class="mx-2 text-xs">{{work.additionalInfo.name }}</p>
                                            </div>
                                            <div class="flex" v-if="Object.keys(work.additionalInfo).includes('approver')">
                                              <div v-if="work.additionalInfo.action == 10301">
                                                <p class="font-semibold text-xs">{{'Sent Approval for -'}}</p>
                                              </div>
                                              <div v-if="work.additionalInfo.statusCode == 10403">
                                                <p class="font-semibold text-xs">{{'Approved Approval -'}}</p>
                                              </div>
                                              <div class="flex" v-if="work.additionalInfo.statusCode == 10410">
                                                <p class="font-semibold text-xs">{{'Rejected Approval -'}}</p>
                                              </div>
                                              <p class="mx-2 text-xs text-justify">{{work.additionalInfo.name }}</p>
                                            </div> 
                                            <div class="flex items-center" v-if="Object.keys(work.additionalInfo).includes('previousStatus')">
                                                <div>
                                                    <p class="font-semibold text-xs">{{'Updated the status :'}}</p>
                                                </div>
                                            <!-- <div v-if="checkKey(work.additionalInfo,'action')" class="flex">
                                              <div class="font-semibold text-xs w-12">Approval :</div>
                                              <div class="text-xs w-88 ">{{ work.additionalInfo.checkapproval }}</div>
                                              <div v-for="(approval, number) in presentFindingTaskObj.approvals" :key="number" class="bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full">
                                                <div class="initials">{{extractInitials(getPersonName(work.additionalInfo.createdBy))}}</div>
                                                <div class="font-semibold mt-1 text-xs">{{ getPersonName(work.additionalInfo.createdBy) }}</div>
                                                <div v-if="work.additionalInfo.statusCode == 10401" class="mx-2 mt-1 text-xs"> {{' Requested an approval '}} </div>
                                                <div v-else-if="work.additionalInfo.statusCode == 10410" class="mx-2 mt-1 text-xs"> {{' Rejected an approval '}} </div>
                                                <div v-else-if="work.additionalInfo.statusCode == 10403" class="mx-2 mt-1 text-xs"> {{' Approved an approval '}} </div>
                                                <div class="font-semibold mt-1 text-xs">{{work.additionalInfo.createdAt}}</div>
                                              </div>
                                            </div> -->
                                            <div class="flex ml-4">
                                                <div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorFindingBg(work.additionalInfo.previousStatus)">
                                                    <div :class="colorFindingText(work.additionalInfo.previousStatus)">
                                                        {{ getStatusLabel(work.additionalInfo.previousStatus) }}
                                                    </div>
                                                </div>
                                                <div class="mx-4 flex items-center"><img src="@/assets/arrowRight.svg"/></div>
                                                <div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorFindingBg(work.additionalInfo.updatedStatus)">
                                                  <div :class="colorFindingText(work.additionalInfo.updatedStatus)">
                                                    {{ getStatusLabel(work.additionalInfo.updatedStatus) }}
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            </div>

                                          
                                          <!-- <div v-if="Object.keys(work.additionalInfo).includes('evidence')" class="flex">
                                            <div class="font-semibold text-xs w-12">Comment :</div>
                                            <div class="text-xs w-88 ">{{ work.addtionalInfo.comment }}</div>
                                          </div>
                                          <div class="flex" v-if="Object.keys(work.additionalInfo).includes('evidence')">
                                            <p class="font-semibold text-xs">{{'Uploaded the Evidence -'}}</p>
                                            <p class="mx-2 text-xs">{{ work.additionalInfo.evidence }}</p>
                                          </div>
                                          
                                          <div class="flex" v-if="Object.keys(work.addtionalInfo).includes('assignee')">
                                            <p class="font-semibold text-xs">{{'Assigned the Task To -'}}</p>
                                            <p class="mx-2 text-xs">{{ getPersonName(work.addtionalInfo.assignee) }}</p>
                                          </div> -->
                                          
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                              <!-- </div> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                  </TabPanels>  
                </Tabs>  
            <div
              class="w-20 border taskDetailsRightBar rounded-sm border-lightgrey"
            >
              <div class="m-3">
                <div class="pb-2 border-b border-lightgrey">
                  <h1>Task Details</h1>
                </div>
                <div v-if="tabDataLoading == true">
                  <div class="flex items-center justify-center w-full h-16 skeleton">
								    <dots-loader/>
                  </div>
                </div>
                <div v-else class="pt-1.5 overflow-y-scroll thirtyWidthToggle">
                  <div class="flex flex-col">
                    <label class="controllabel">Task Status</label>
                    <div>
                      <div v-if="TaskDetailsDropDown.taskStatus == 10418" class="bg-error textColorWhite inputboxstyling1 cursor-pointer mt-2 mb-3">
                           <div class="bg-error textColorWhite">{{'Terminated'}}</div>
                      </div>
                      <input disabled v-else-if="TaskDetailsDropDown.taskStatus == 10403" type="text" placeholder="Status" class="completedBox inputboxstyling mt-2 " value="Completed" />
                      <!-- (newAssignee.value != userInfo._id && presentFindingTaskObj.teamOwner != userInfo._id) ||  -->
                       <Select
                        v-model="TaskDetailsDropDown.taskStatus"
                        v-if="checkreviewer(presentFindingTaskObj.reviewer) &&
                          (TaskDetailsDropDown.taskStatus == 10414 ||
                            TaskDetailsDropDown.taskStatus == 10421)"
                        :options="reviewerTask"
                        :disabled=" !isAddDisabled(10302)"
                        appendTo="body"
                        @change="onTaskStatusChange" 
                        optionLabel="value"
                        optionValue="id"
                        class="w-full mt-2"
                        :class="changeBackground(),
                        TaskDetailsDropDown.taskStatus == 10403?'completed-status-arrow':'custom-select'"
                        :optionDisabled="isOptionDisabled"
                    />
                      <!-- <select
                        class="mt-2 mb-3 inputboxstyling1  cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
                        :class="changeBackground(),
                        TaskDetailsDropDown.taskStatus == 10403?'completed-status-arrow':'custom-select'"
                        v-if="checkreviewer(presentFindingTaskObj.reviewer) &&
                          (TaskDetailsDropDown.taskStatus == 10414 ||
                            TaskDetailsDropDown.taskStatus == 10421 ||
                            TaskDetailsDropDown.taskStatus == 10403)"
                            
                        :disabled="TaskDetailsDropDown.taskStatus == 10403"
                        v-model="TaskDetailsDropDown.taskStatus"
                        @change="
                          updateTaskStatus(TaskDetailsDropDown.taskStatus)
                        "
                      >
                        <option value="" selected disabled hidden>
                          Please select one
                        </option>
                        <option
                          v-for="i in reviewerTaskData" 
                          :value="i.id"
                          :key="i"
                        >
                          {{ i.value }}
                        </option>
                      </select> -->
                      <!-- (newAssignee.value != userInfo._id  && presentFindingTaskObj.teamOwner != userInfo._id) ||  -->
                        <Select
                        v-model="TaskDetailsDropDown.taskStatus"
                        v-else-if="
                          !checkreviewer(presentFindingTaskObj.reviewer) &&
                          (TaskDetailsDropDown.taskStatus == 10401 ||
                            TaskDetailsDropDown.taskStatus == 10402 ||
                            TaskDetailsDropDown.taskStatus == 10408 ||
                            TaskDetailsDropDown.taskStatus == 10414)"
                        :options="taskStatusInfo"
                        :disabled="
                          TaskDetailsDropDown.taskStatus == 10414 ||
                          TaskDetailsDropDown.taskStatus == 10421 ||
                          TaskDetailsDropDown.taskStatus == 10403  || !isAddDisabled(10302)
                        "
                        appendTo="body"
                        @change="onTaskStatusChange" 
                        optionLabel="value"
                        optionValue="id"
                        class="w-full border-solid border border-lightgrey mt-2"
                        :class="changeBackground()"
                        :optionDisabled="isOptionDisabled"
                    />
                      <!-- <select
                        class="mt-2 mb-3  custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
                        :class="changeBackground()"
                        v-else-if="
                          !checkreviewer(presentFindingTaskObj.reviewer) &&
                          (TaskDetailsDropDown.taskStatus == 10401 ||
                            TaskDetailsDropDown.taskStatus == 10402 ||
                            TaskDetailsDropDown.taskStatus == 10408 ||
                            TaskDetailsDropDown.taskStatus == 10414)"
                        :disabled="
                          TaskDetailsDropDown.taskStatus == 10414 ||
                          TaskDetailsDropDown.taskStatus == 10421 ||
                          TaskDetailsDropDown.taskStatus == 10403
                        "
                        v-model="TaskDetailsDropDown.taskStatus"
                        @change="
                          updateTaskStatus(TaskDetailsDropDown.taskStatus)
                        "
                      >
                        <option value="" selected disabled hidden>
                          Please select one
                        </option>
                        <option
                          v-for="i in taskStatusData"
                          :value="i.id"
                          :key="i"
                        >
                          {{ i.value }}
                        </option>
                      </select> -->
                    </div>
                    <div>
                      <div
                        v-if="
                          !checkreviewer(presentFindingTaskObj.reviewer) &&
                          presentFindingTaskObj.statusCode == 10421"
                        :class="changeBackground()"
                        class="inputboxstyling1 disabled cursor-pointer mt-2 mb-3"
                      >
                        <div
                          :class="changeBackground()"
                          @change="
                            updateTaskStatus(TaskDetailsDropDown.taskStatus)"
                        >
                          {{
                            reviewerTask.find((data) => {
                              return (
                                data.id == presentFindingTaskObj.statusCode
                              );
                            }).value
                          }}
                        </div>
                      </div>
                      <div
                        v-if="
                          checkreviewer(presentFindingTaskObj.reviewer) &&
                          (TaskDetailsDropDown.taskStatus == 10401 ||
                            TaskDetailsDropDown.taskStatus == 10402 ||
                            TaskDetailsDropDown.taskStatus == 10408) "
                        :class="changeBackground()"
                        class="inputboxstyling1 disabled cursor-pointer mt-2 mb-3"
                      >
                        <div
                          :class="changeBackground()"
                          @change="
                            updateTaskStatus(TaskDetailsDropDown.taskStatus)"
                        >
                          {{
                            taskStatusInfo.find((data) => {
                              return (
                                data.id == presentFindingTaskObj.statusCode
                              );
                            }).value
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div>
                      <label class="controllabel">Assignee</label>
                      <div v-if="TaskDetailsDropDown.taskStatus == 10403 || TaskDetailsDropDown.taskStatus == 10417 || presentFindingTaskObj.statusCode == 10403 || presentFindingTaskObj.statusCode == 10418 || presentFindingTaskObj.reviewer == userInfo._id  || (presentFindingTaskObj.teamOwner != userInfo._id && ( newAssignee.value != userInfo._id))">
                         <p class="mt-2"> {{ newAssignee.label}}</p>
                      </div>
                      <div v-else>
                            <!-- <multiselect
                                v-model="presentFindingTaskObj.assignee"
                                :options="userOptions"
                                :showNoOptions="false"
                                @search-change="asyncFind"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="true"
                                label="label"
                                open-direction="bottom"
                                track-by="value"
                                @select="
                                  updateAssignedMember(presentFindingTaskObj.assignee)
                                "
                                :searchable="true"
                                :hideArrow="false"
                                placeholder="Assigned-To"
                                deselectLabel=""
                                selectLabel=""
                                class="custom-multiselect mt-2"
                              >
                        <template v-slot:noResult>
                          <span class="text-xs">No Members Found</span>
                        </template>
                      </multiselect> -->
                      <AutoComplete 
                        v-model="presentFindingTaskObj.assignee"
                        :suggestions="userOptions"
                        @complete="asyncFind"
                        @item-select="updateAssignedMember(presentFindingTaskObj.assignee)"
                        optionLabel="label"
                        optionValue="value"
                        :forceSelection="true"
                        placeholder="Assigned-To"
                        class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <label class="controllabel">Reviewer</label><br />
                    <div v-if="presentFindingTaskObj.reviewer != undefined || presentFindingTaskObj.reviewer != null" class="mt-2 text-sm">
                      {{ getPerson(presentFindingTaskObj.reviewer) }}
                    </div>
                    <p class="mt-2 text-sm" v-else>N/A</p>
                  </div>
                  <div class="mb-3 mt-4" v-if='((presentFindingTaskObj.appId && presentFindingTaskObj.appId==10003)|| presentFindingTaskObj.treatmentType!=undefined)'>
                      <label class="controllabel mb-2">Treatment Type</label><br>
            
                      <div class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="treatmentTypeBgColor(presentFindingTaskObj.treatmentType)">
                        <div class="text-xs" :class="treatmentTypeTextColor(presentFindingTaskObj.treatmentType)">
                        {{ presentTask(presentFindingTaskObj.treatmentType)||'N/A' }}
                        </div>
                      </div>
                      
                    </div>
                  <div class="mt-3">
                    <label class="controllabel">Due Date</label><br>
                    <p v-if="presentFindingTaskObj.dueDate != undefined || presentFindingTaskObj.dueDate != null" class="mt-2 text-sm rounded w-24" :class="shouldStyleDueDate(presentFindingTaskObj) ? colorForDueDate(presentFindingTaskObj.dueDate) : ''"">{{ formatDate(presentFindingTaskObj.dueDate) }}</p>
                    <p class="mt-2 text-sm" v-else>N/A</p>
                        <!-- {{ getPersonName(presentTaskObject.department) }} -->
                </div>
                  <div class="mt-3">
                    <label class="controllabel">Team Representative</label><br />
                    <div v-if="presentFindingTaskObj.teamOwner != undefined || presentFindingTaskObj.teamOwner != null" class="mt-2 text-sm">
                      {{ getPersonName(presentFindingTaskObj.teamOwner) }}
                    </div>
                    <p class="mt-2 text-sm" v-else>N/A</p>
                  </div>
                  <div class="mt-3">
                    <label class="controllabel">Team</label><br />
                    <div v-if="presentFindingTaskObj.department != undefined || presentFindingTaskObj.department != null" class="mt-2 text-sm">
                      {{ getTeamName(presentFindingTaskObj.department) }}
                    </div>
                    <p class="mt-2 text-sm" v-else>N/A</p>
                  </div>
                  <div class="mt-3">
                    <label class="controllabel">Location</label><br />
                    <!-- <div v-if="presentFindingTaskObj.entitytypecodeid == 20303 && presentFindingTaskObj.entity != undefined || presentFindingTaskObj.entity != null" class="mt-2 text-sm">
                      {{ getLocationName(presentFindingTaskObj.entity) }}
                    </div>
                    <div class="mt-2" v-else-if="presentFindingTaskObj.entitytypecodeid == 20301">{{'Global'}}</div>
                    <p class="mt-2 text-sm" v-else>N/A</p> -->
                    <!-- <div v-if="presentFindingTaskObj.department != undefined || presentFindingTaskObj.department != null" class="mt-2 text-sm">{{ getDeptEntity(presentFindingTaskObj.department) }}</div> -->
                    <!-- <div v-if="Object.keys(presentFindingTaskObj).includes('location') && !Object.keys(presentFindingTaskObj).includes('entity') && presentFindingTaskObj.location != '' && presentFindingTaskObj.location != null && presentFindingTaskObj.location != undefined" class="mt-2 text-sm">{{ presentFindingTaskObj.location }}</div>
                    <div v-else-if="Object.keys(presentFindingTaskObj).includes('entity') && presentFindingTaskObj.entity != '' && presentFindingTaskObj.entity != null && presentFindingTaskObj.entity != undefined">{{ getEntity(presentFindingTaskObj.entity) }}</div>
                    <p class="mt-2 text-sm" v-else>N/A</p> -->
                    <div v-if="Object.keys(presentFindingTaskObj).includes('location') && presentFindingTaskObj.location != undefined && presentFindingTaskObj.location != ''" class="mt-2 text-sm">{{getEntityName(presentFindingTaskObj.location)}}</div>
                    <div v-else-if="Object.keys(presentFindingTaskObj).includes('location') && !Object.keys(presentFindingTaskObj).includes('entity') && presentFindingTaskObj.location != '' && presentFindingTaskObj.location != null" class="mt-2 text-sm">{{ getEntity(presentFindingTaskObj.location) }}</div>
                      <div v-else-if="Object.keys(presentFindingTaskObj).includes('entity') && presentFindingTaskObj.entity != '' && presentFindingTaskObj.entity != null && presentFindingTaskObj.entity != undefined">{{ getEntity(presentFindingTaskObj.entity) }}</div>
                      <div v-else-if="Object.keys(presentFindingTaskObj).includes('location') && presentFindingTaskObj.location=='' && presentFindingTaskObj.department!=''">{{getLocationNameForSystem(presentFindingTaskObj.department)}}</div>
                      <div v-else-if='presentFindingTaskObj.location==null'  >
                          <div v-for="val in users" :key='val._id'>
                            <div v-if="val._id==presentFindingTaskObj.department && val.entityType==20301">{{'Global'}}</div>
                          </div>
                      </div>
                      <p class="mt-2 text-sm" v-else>N/A</p> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <popup v-if="importpopUp" :popUp="importpopUp">
      <div
        class="overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex"
      >
        <div class="relative w-full max-w-xl">
          <!--content-->
          <div
            class="border-0 rounded relative flex flex-col w-full bg-white h-screen"
          >
            <!--header-->
            <div
              class="flex items-center justify-between popupheadingcontainer rounded"
            >
              <h1>{{ evidenceAttachMode === 'url' ? 'Attach Link' : 'Attach File' }}</h1>
              <button
                class="p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                @click="onCancelIcon()"
              >
                <img src="@/assets/cancel.svg" class="h-5 w-5 cursor-pointer" />
              </button>
            </div>
            <div class="border-b border-solid border-lightgrey ml-4 mr-4"></div>
        <div class='flex flex-col h-full'>
          <div class="flex-1 overflow-auto">
            <div class="impactcontainer popupbodycontainer">
              <div class="formcontainer flex flex-col">
                <div class="row flex flex-col mt-2">
                  <div>
                    <label class="controllabel">{{ evidenceAttachMode === 'url' ? 'Title' : 'File Name' }} </label>
                    <input
                      class="inputboxstyling mt-2"
                      type="text"
                      v-model.trim="inputFileName"
                      :placeholder="evidenceAttachMode === 'url' ? 'Evidence title' : 'Filename'"
                      @input="v$.inputFileName.$touch()" 
                      :class="{ 'is-invalid': v$.inputFileName.$error }"
                    />
                    <div v-if="v$.inputFileName.$error" class="text-red-500">
                      <div class="error-text" v-if="v$.inputFileName.required.$invalid">Required</div>
                      <div v-else-if="v$.inputFileName.required && v$.inputFileName.restrictCharacters50.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                    </div>
                  </div>
                   <div class="pt-3" v-if="evidenceAttachMode === 'file'">
                <label class="controllabel">Attachment</label>
                <input
                  type="file"
                  ref="fileInput"
                  class="hidden"
                  id="upload"
                  @change="handleFileUpload"
                />
                <div 
                  class="w-auto rounded-sm mt-2 p-8
                        flex flex-col items-center justify-center text-center transition
                        border-2 border-dashed border-lightgrey bg-whitegrey"
                  :class="{
                    'is-invalid': v$.fileToUpload.$error || pdfValidation,
                    'border-primary': isDragOver
                  }"
                  @dragenter.prevent="onDragOver"
                  @dragover.prevent="onDragOver"
                  @dragleave.prevent="onDragLeave"
                  @drop.prevent="onFileDrop"
                >
                  <img
                    src="@/assets/fileUploadIcon.svg"
                    class="h-10 w-10 mb-3"
                    alt="Upload file"
                  />

                  <p v-if="fileName === ''" class="text-sm font-semibold text-darkblue mb-4">
                    Drag and drop your file here
                  </p>
                  <p v-else class="text-sm font-semibold text-primary mb-4">
                    {{ fileName }}
                  </p>
                  <div class="flex items-center justify-center gap-2">
                    <label for="upload" class="cursor-pointer">
                      <span class="btnprimary text-xs gap-1">
                        <img src="@/assets/Browse.svg" class="h-4 w-4" alt="" />
                        Browse
                      </span>
                    </label>

                    <button
                      type="button"
                      class="filterButton text-xs gap-1"
                      :class="fileName === '' ? 'filterButtondisabled pointer-events-none' : ''"
                      :disabled="fileName === ''"
                      @click="clearSelectedFile"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
                <div class="min-h-[22px] text-red-500">
                  <div
                    v-if="v$.fileToUpload.$invalid && !pdfValidation && (v$.fileToUpload.$error || pdfValidation)"
                    class="error-text text-xs"
                  >
                    File upload is required
                  </div>
                  <div
                    v-if="pdfValidation && !v$.fileToUpload.$invalid"
                    class="text-red-500 text-xs"
                  >
                    This File Format is not Supported
                  </div>
                </div>
                <div class="mt-2 flex flex-col items-center">
                <p class="text-xs text-placeholder">
                  Accepted Formats: PDF, JPG, PNG, ZIP, TXT, XLS, DOC, MP4
                </p>
                <p class="text-xs text-placeholder mt-1">
                  Maximum File Size: 50 MB
                </p>
              </div>
              </div>
                  <div class="pt-3" v-if="evidenceAttachMode === 'url'">
                    <label class="controllabel">URL</label>
                    <input
                      class="inputboxstyling mt-2"
                      type="url"
                      v-model.trim="evidenceUrl"
                      placeholder="URL"
                      @input="v$.evidenceUrl.$touch()"
                      :class="{ 'is-invalid': v$.evidenceUrl.$error }"
                    />
                    <div v-if="v$.evidenceUrl.$error" class="text-red-500">
                      <div class="error-text text-xs" v-if="v$.evidenceUrl.required.$invalid">Required</div>
                      <div class="error-text text-xs" v-else-if="v$.evidenceUrl.httpUrl.$invalid">URL must use http or https</div>
                    </div>
                  </div>
                  <div class="pt-3 w-1/2">
                    <label class="controllabel">Evidence Date</label>
                    <input
                      v-model="evidenceDate"
                      type="date"
                      class="mt-2 w-full"
                      @focus="openCalendar"
                      style="height:28px"
                      onkeydown="return false"
                      :class="{
                        'inputboxstylingForSelectAtPopup': evidenceDate == '',
                        'stylingForInputboxstylingForSelectAtPopup': evidenceDate != '',
                        'is-invalid':v$.evidenceDate.$error
                        }"
                      
                      placeholder="Select Date"
                      :max="todayDate"

                    />
                    <div v-if="v$.evidenceDate.$error" class="text-red-500">
                      <div v-if="v$.evidenceDate.$invalid" class="error-text text-xs">Evidence date is required</div>
                    </div>
                </div>
                  
                </div>
              </div>
            </div>
          </div>
          <!--footer-->
          <div>
              <div class="border-b border-solid border-lightgrey mx-5"></div>
            <div class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5">
            <button
              class="btnprimary"
              :disabled="clickOnButtonAtAddingFile"
              @click="handleFileChange"
              :class="
                isEvidenceSaveDisabled
                  ? 'btndisabled pointer-events-none '
                  : 'btnprimary'"
            >
              Save
            </button>
          </div>
          </div>
          </div>
          </div>
        </div>
      </div>
    </popup>
    <popup v-if="showApprovalPopup" :popUp="showApprovalPopup">
      <template v-slot:header>
        <div
          class="flex items-center justify-between popupheadingcontainer rounded"
        >
          <h1>Approval</h1>

          <button class="float-right text-3xl" @click="onCrossbtn()">
            <img src="@/assets/cancel.svg" class="cursor-pointer" />
          </button>
        </div>
      </template>
<div class='flex flex-col h-full'>
    <div class="flex-1 overflow-auto">
      <div class="popup-business">
        <div>
          <div>
            <div class="statuscontainer popupbodycontainer">
              <div class="formcontainer flex flex-col">
                <div class="row flex flex-row mt-2">
                  <div class="w-1/2">
                    <label class="controllabel">Name of the Authority</label>
                    <!-- <div class="inputboxstyling" disabled>
                      {{ getPersonName(presentFindingTaskObj.teamOwner) }}
                    </div> -->
                    <AutoComplete 
                        v-model="taskObj.approver"
                        :suggestions="userOptions"
                        @complete="asyncApproverFind"
                        optionLabel="label"
                        optionValue="value"
                        :forceSelection="true"
                        placeholder="Name of the Authority"
                        :class="{ 'p-invalid': v$.taskObj.approver.$error }"
                        class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
                        />
                    <!-- <multiselect
                        v-model="taskObj.approver"
                        :options="userOptions"
                        :showNoOptions="false"
                        @search-change="asyncApproverFind"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="true"
                        label="label"
                        open-direction="bottom"
                        :hide-selected="true"
                        track-by="value"
                        :searchable="true"
                        :hideArrow="false"
                        placeholder="Name of the Authority"
                        deselectLabel=""
                        selectLabel=""
                        class="custom-multiselect mt-2"
                        :class="{ 'is-invalidmultiselect': v$.taskObj.approver.$error }"
                      >
                        <template v-slot:noResult>
                          <span class="text-xs">No Members Found</span>
                        </template>
                      </multiselect> -->
                      <div v-if="v$.taskObj.approver.$error" class="text-red-500">
                        <div class="error-text" v-if="v$.taskObj.approver.required.$invalid">Required</div>
                      </div>
                  </div>
                </div>
                <div class="row flex flex-row upperspacing">
                  <div class="w-full">
                    <label class="controllabel"
                      >Justification or Comments for Approving</label
                    >
                    <textarea
                      class="inputboxstyling mt-2"
                      placeholder="Comments"
                      v-model.trim="taskObj.approvalComments"
                      @input="v$.taskObj.approvalComments.$touch()" 
                      :class="{ 'is-invalid': v$.taskObj.approvalComments.$error }"
                    />
                    <div v-if="v$.taskObj.approvalComments.$error" class="text-red-500">
                      <div class="error-text" v-if="v$.taskObj.approvalComments.required.$invalid">Required</div>
                      <div v-else-if="v$.taskObj.approvalComments.required && v$.taskObj.approvalComments.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="border-b border-solid border-lightgrey mx-5"></div>
      <div
            class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
          >
            <button
              class="btnprimary mr-2"
              :class="
                !taskObj.approver && !taskObj.approvalComments
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="onCancelbtnAtApproval()"
            >
              Reset
            </button>
            <button
              class="btnprimary"
              :disabled="clickOnButton"
              :class="
                !taskObj.approver && !taskObj.approvalComments
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="applyAuthority()"
            >
              Save
            </button>
      </div>
    </div>
      </div>
    </popup>
    <popup v-if="showRejectPopupForNormalApproval" :popUp="showRejectPopupForNormalApproval">
      <template v-slot:header>
        <div
          class="flex items-center justify-between popupheadingcontainer rounded"
        >
          <h1>Justification to Reject an Approval</h1>

          <button class="float-right text-3xl" @click="onCrossBtnForNormalApproval()">
            <img src="@/assets/cancel.svg" class="cursor-pointer" />
          </button>
        </div>
      </template>
    <div class='flex flex-col h-full'>
    <div class="flex-1 overflow-auto">
      <div class="popup-business">
        <div>
          <div>
            <div class="statuscontainer px-4 py-4">
              <div class="formcontainer flex flex-col w-full">
                    <label class="controllabel"
                      >Justification or Comments for Approving</label
                    >
                    <textarea
                      class="inputboxstyling mt-2"
                      placeholder="Comments"
                      v-model.trim="normalJustification.justification"
                      @input="v$.normalJustification.justification.$touch()" 
                      :class="{ 'is-invalid': v$.normalJustification.justification.$error }"
                    />
                    <div v-if="v$.normalJustification.justification.$error" class="text-red-500">
                      <div v-if="v$.normalJustification.justification.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                    </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div>
      <div class="border-b border-solid border-lightgrey mx-5"></div>
        <div
            class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
          >
            <button
              class="btnprimary mr-2"
              :class="
                normalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="onCancelbtnForNormalApproval()"
            >
              Reset
            </button>
            <button
            :disabled="clickOnButtonForNormal"
              class="btnprimary"
              :class="
                normalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="ApprovalforInprogress(10410)"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </popup>
    <popup v-if="showRejectPopupAtInReview" :popUp="showRejectPopupAtInReview">
      <template v-slot:header>
        <div
          class="flex items-center justify-between popupheadingcontainer rounded"
        >
          <h1>Justification to Reject an Approval</h1>

          <button class="float-right text-3xl" @click="onCrossBtnForFinalApproval()">
            <img src="@/assets/cancel.svg" class="cursor-pointer" />
          </button>
        </div>
      </template>
  <div class='flex flex-col h-full'>
    <div class="flex-1 overflow-auto">
      <div class="popup-business">
        <div>
          <div>
            <div class="statuscontainer px-4 py-4">
              <div class="formcontainer flex flex-col w-full">
                    <label class="controllabel"
                      >Justification or Comments for Approving</label
                    >
                    <textarea
                      class="inputboxstyling mt-2"
                      placeholder="Comments"
                      v-model.trim="finalJustification.justification"
                      @input="v$.finalJustification.justification.$touch()" 
                      :class="{ 'is-invalid': v$.finalJustification.justification.$error }"
                    />
                    <div v-if="v$.finalJustification.justification.$error" class="text-red-500">
                      <div v-if="v$.finalJustification.justification.restrictCharacters1000.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                    </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div>
      <div class="border-b border-solid border-lightgrey mx-5"></div>
        <div
            class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
          >
            <button
              class="btnprimary mr-2"
              :class="
                finalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="onCancelbtnForFinalApproval()"
            >
              Reset
            </button>
            <button
              :disabled="clickOnButtonForFinal"
              class="btnprimary"
              :class="
                finalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="approveOrRejectForActionTasktoComplete(10401, 9)"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </popup>
    <div v-if="showDeleteEvidenceConfirm" class="evidence-delete-confirm">
      <div class="evidence-delete-backdrop" @click="cancelDeleteEvidence"></div>
      <div class="evidence-delete-dialog">
        <div class="evidence-delete-dialog-title">
          <div class="evidence-delete-warning">
            <img src="@/assets/warning.svg" class="evidence-delete-warning-icon" alt="" />
          </div>
          <span>Delete Evidence</span>
        </div>
        <p class="evidence-delete-dialog-message">Are you sure you want to delete this evidence?</p>
        <div class="evidence-delete-dialog-actions">
          <button type="button" class="evidence-delete-cancel" @click="cancelDeleteEvidence">Cancel</button>
          <button type="button" class="evidence-delete-ok" @click="confirmDeleteEvidence">OK</button>
        </div>
      </div>
    </div>
    <div v-if="linkEvidencePopup" class="link-existing-confirm">
      <div class="link-existing-backdrop" @click="closeLinkEvidencePopup"></div>
      <div class="link-existing-dialog">
        <div class="link-existing-title">
          <span class="link-existing-warning" aria-hidden="true">
            <img src="@/assets/warning.svg" class="link-existing-warning-icon" alt="" />
          </span>
          <span>Link Existing Evidence</span>
        </div>
        <p class="link-existing-message">Select evidence from the past year listed below.</p>
        <div class="link-existing-tables">
          <div class="link-existing-section-row">
            <div class="link-existing-section">EXISTING EVIDENCE ({{ filteredSortedExistingEvidences.length }})</div>
            <button type="button" class="filterButton flex" @click="toggleExistingEvidenceFilters">
              <img src="@/assets/filter.svg" class="filterIcon" />
              Filters
            </button>
          </div>
          <div class="link-existing-table-wrap" :class="{ 'link-existing-table-wrap--empty': filteredSortedExistingEvidences.length === 0 }">
            <table class="link-existing-table">
              <thead>
                <tr>
                  <th class="link-existing-col-check"></th>
                  <th class="cursor-pointer" @click="sortExistingEvidence('filename')">
                    <div class="flex table-header-label-wrap">
                      <div class="table-header-label">TITLE</div>
                      <div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'filename' ? existingEvidenceSortClass : 'opacity-50'"></div>
                    </div>
                  </th>
                  <th class="cursor-pointer" @click="sortExistingEvidence('sourceTaskId')">
                    <div class="flex table-header-label-wrap">
                      <div class="table-header-label">TASK ID</div>
                      <div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'sourceTaskId' ? existingEvidenceSortClass : 'opacity-50'"></div>
                    </div>
                  </th>
                  <th class="cursor-pointer" @click="sortExistingEvidence('evidenceType')">
                    <div class="flex table-header-label-wrap">
                      <div class="table-header-label">TYPE</div>
                      <div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceType' ? existingEvidenceSortClass : 'opacity-50'"></div>
                    </div>
                  </th>
                  <th class="cursor-pointer" @click="sortExistingEvidence('evidenceDate')">
                    <div class="flex table-header-label-wrap">
                      <div class="table-header-label">EVIDENCE DATE</div>
                      <div class="sort cursor-pointer" :class="existingEvidenceSortKey === 'evidenceDate' ? existingEvidenceSortClass : 'opacity-50'"></div>
                    </div>
                  </th>
                </tr>
                <tr v-if="showExistingEvidenceFilters" class="link-existing-filter-row">
                  <td class="link-existing-col-check"></td>
                  <td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.filename" placeholder="Search" @click.stop /></td>
                  <td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.sourceTaskId" placeholder="Search" @click.stop /></td>
                  <td><input type="text" class="searchForInputBoxStyling" v-model.trim="existingEvidenceFilters.evidenceType" placeholder="Search" @click.stop /></td>
                  <td></td>
                </tr>
              </thead>
              <tbody v-if="filteredSortedExistingEvidences.length">
                <tr v-for="row in filteredSortedExistingEvidences" :key="row.optionKey">
                  <td class="link-existing-col-check">
                    <input type="checkbox" :checked="isExistingEvidenceSelected(row)" @change="toggleExistingEvidence(row)" />
                  </td>
                  <td :title="row.filename">{{ row.filename }}</td>
                  <td>{{ row.sourceTaskId }}</td>
                  <td>{{ existingEvidenceTypeLabel(row) }}</td>
                  <td>{{ row.evidenceDate ? formatFileAttachedTime(row.evidenceDate) : 'N/A' }}</td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td class="link-existing-empty" colspan="5">No Records Found</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="link-existing-actions">
          <button type="button" class="link-existing-cancel" @click="closeLinkEvidencePopup">Cancel</button>
          <button type="button" class="link-existing-save" @click="saveLinkedEvidence" :class="selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : ''">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>

.imageStyling{
	width:30px !important;
	height:30px !important;
}

.completedBox{
	background-color: #00B050 !important;
	font-weight:600 !important;
	color: white;
	pointer-events: none;
}
:deep(.p-select.p-disabled.bg-disabledgrey),.bg-disabledgrey,.p-select.bg-disabledgrey.p-focus{
  background-color: #a4a4a4 !important;
  border:1px solid #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-yellow),.bg-yellow,.p-select.bg-yellow.p-focus{
  background-color: #FF9900 !important;
  border:1px solid #FF9900 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-forReview),.bg-forReview,.p-select.bg-forReview.p-focus{
  background-color: #085B96 !important;
  border:1px solid #085B96 !important;
  font-weight: 600 !important;
}
.p-select.p-disabled .p-select-dropdown{
  background-color: #a4a4a4 !important;
}
:deep(.p-select.p-disabled.bg-electricGreen),.bg-electricGreen,.p-select.bg-electricGreen.p-focus{
  background-color: #8600F0 !important;
  border:1px solid #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-lightgreen),.bg-lightgreen,.p-select.bg-lightgreen.p-focus{
  background-color: #00B050 !important;
  border:1px solid #00B050 !important;
  font-weight:600 !important;
}
:deep(.p-select.p-disabled.bg-darkred),.bg-darkred,.p-select.bg-darkred.p-focus{
  background-color: #C00000 !important;
  border:1px solid #C00000 !important;
  font-weight:600 !important;
}
:deep(.p-select.p-disabled.bg-error),.bg-error,.p-select.bg-error.p-focus{
  background-color: #FF0000 !important;
  border:1px solid #FF0000 !important;
  font-weight:600 !important;
}
:deep(.p-select.p-disabled.bg-primary),.bg-primary,.p-select.bg-primary.p-focus{
  background-color: #1976D2 !important;
  border:1px solid #1976D2 !important;
  font-weight:600 !important;
}
:deep(.p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-dropdown) {
  display: none !important;
}

:deep(.p-select-dropdown-icon){
  color: white !important;
}
.progressbarB {
  border: 2px solid #e9e9e9;
  background: #e9e9e9;
  position: relative;
  top: -8px;
  z-index: 1;
}
:deep(.p-tab){
  padding: 0px 0px 5px 0px !important;
}
.w-80{
  width: 80%;
}
.w-20{
  width: 20%;
}
.numberBorder {
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
  border-bottom: 1px solid #e9e9e9;
}
.numberNavy {
  border-left: 1px solid #152a43;
  border-left-width: 2px;
}
.progress {
  background: #1976d2;
  position: relative;
  border-radius: 4px;
  z-index: 2;
}
.primaryBackground {
  background-color: #1976d2;
}
.descriptionToggle {
  height: 97%;
}
.tabStructure {
  height: calc(100vh - 165px);
}
.thirtyWidthToggle::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent;
}

.thirtyWidthToggle::-webkit-scrollbar-thumb {
  background: transparent;
}
.thirtyWidthToggle {
  height: calc(100vh - 250px);
}
.descriptionToggle::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent;
}
.fontSize10PX{
  font-size : 10px
}
.inputboxstyling1 {
  display: block;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgba(233, 233, 233, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  /* background-color: rgba(255, 255, 255, var(--tw-bg-opacity)); */
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  --tw-text-opacity: 1;
  /* color: rgba(77, 77, 77, var(--tw-text-opacity)); */
}
.descriptionToggle::-webkit-scrollbar-thumb {
  background: transparent;
}
.heightFixing {
  height: calc(100vh - 220px);
  /* height : 64vh; */
}
.w-12{
  width:12%;
}
.w-88{
  width:88%;
}
.paddingBottomForFindings {
  padding-bottom: 10.5px;
}
option {
  background-color: #ffffff;
  color: #000000;
  border-color: pink transparent transparent transparent;
}
.textColorWhite {
  color: white;
}
.completed-status-arrow{
  background-image: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  opacity:1 !important;
}
.custom-select {
  /* background-image: url("@/assets/Collapse.svg") !important; */
  background-repeat: no-repeat no-repeat;
  background-position: center center;
  background-size: 12px 12px;
  background-position: right 15px center; /* Change the px value here to change the distance */
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
.marginBottomForDoc {
  margin-bottom: 3px;
}
.marginTopForDoc {
  margin-top: 2.5px;
}
.marginBottomZero {
  margin-bottom: 0px;
}
.pendingEvidence {
  background-color: #8600f040;
}
.labelWidth {
  min-width: 7rem;
}
.framework {
  padding: 12px 170px 12px 12px;
}
.findingCategory {
  padding: 12px 80px 12px 12px;
}
.paddingAdjustment{
  padding-bottom : 7px;
}
.heightForDiv{
  height : 29.333px;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.pxMargin{
 margin-bottom : 1.5px;
}
.btndisabled{
  border :1px solid #e9e9e9
}
.btnprimary1 {
  cursor: pointer;
  border-bottom-right-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgba(21, 42, 67, var(--tw-bg-opacity));
  padding-left: 0.625rem;
  padding-right: 0.625rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 700;
  line-height: 0.75rem;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.borderRed {
  border: 1px solid red !important;
}
.primary{
	color:#1976d2;
}
::-webkit-scrollbar {
	width: 3px !important;
}
.bgDisabledGrey{
	background-color: rgba(164, 164, 164, 0.2);
}
.bgError{
	background-color: rgba(255, 0, 0, 0.2);
}
.bgdarkred{
	background-color: rgba(192, 0, 0, 0.2);
}
.bgYellow{
	background-color: rgba(255, 153, 0, 0.2);
}
.bgLightGreen{
	background-color: rgba(0, 176, 80, 0.2);
}
.bgGreen{
	background-color: rgba(146, 208, 80, 0.2);
}
.bgElectricGreen{
	background-color: rgba(134, 0, 240, 0.2);
}
.bgForReview{
	background-color: rgba(8, 91, 150, 0.2);
}
.bgPrimary{
	background-color: rgba(21, 42, 67, 0.2);
}

 @media only screen and (min-width: 320px) and  (max-width: 820px) {
    :deep(.p-tablist-tab-list){
      width: max-content !important;

    }
  }
:deep(.p-tablist-nav-button){
  box-shadow:none  !important;
}
</style>
<script lang="ts">
import { defineComponent } from "vue";
import breadCrumbs from "@/components/breadCrumb.vue";
import { required, requiredIf, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import popup from "@/components/popup.vue";
import { groupBy } from "lodash";
import { toast } from "@/main";
import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import Multiselect from "vue-multiselect";
// import loader from "../../components/loader.vue";
import commentsEditor from "@/components/commentsEditor.vue";
import dotsLoader from '@/components/dotsLoader.vue';
import pagination from "@/components/pagination.vue";
import { emitter } from '@/main';
import safeHtml from "@/components/safeHtml.vue";
const restrictCharacters50 = helpers.regex(/^.{0,50}$/);
const restrictCharacters60 = helpers.regex(/^.{0,60}$/);
const restrictCharacters100 = helpers.regex(/^.{0,100}$/);
const restrictCharacters300 = helpers.regex(/^.{0,300}$/);
const httpUrl = (value: string) => {
  if (!value) return true;
  try {
    const parsed = new URL(value);
    return parsed.protocol === 'http:' || parsed.protocol === 'https:';
  } catch {
    return false;
  }
};
const restrictCharacters1000 = helpers.regex(/^[\s\S]{0,1000}$/);
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import AutoComplete from "primevue/autocomplete";
import Select from 'primevue/select';
export default defineComponent({
  props: {
    findingId: { type: [String, Number], default: null },
    taskId: { type: [String, Number], default: null },
    modalMode: { type: Boolean, default: false },
  },
  emits: ['header-info', 'open-nested'],
  data(): any {
    return {
      v$: useVuelidate(),
      fileToUpload: null,
      selectedTabIndex: 1,
      riskInformationArray:[],
      tabHead: [
        { displayName: "Details", id: 1 },

        { displayName: "Documents", id: 2 },

        { displayName: "Evidence", id: 3 },

        { displayName: "Comments", id: 4 },

        { displayName: "Approvals", id: 5 },

        { displayName: "History", id: 6 },
      ],
      routesArray: [],
      navIndexNums: { name: "", index: "" },
      selectedControlNumbers: [],
      TaskDetailsDropDown: {
        taskStatus: "",
        assigneeDropDown: "",
      },
      userOptions: [],
      terminateArray: [
        {
          id: 10418,
          status: "Terminated",
        },
      ],
      taskStatusData:  [
          {
            id: 10401,
            value: 'Open'
          },
          {
            id: 10402,
            value: 'In Progress'
          },
          {
            id: 10408,
            value: 'Waiting for Approval'
          },
          {
            id: 10414,
            value: 'ForReview'
          },
          ],
        disabledStatuses:[],
        findingDetails:[],
        taskStatusInfo:[],
        reviewerTask:[],
      reviewerTaskData: [
        {
          id: 10414,
          value: "ForReview",
        },
        {
          id: 10421,
          value: "InReview",
        }
      ],
      findingCategoryData: [
        {
          id: 1,
          value: "Minor",
        },
        {
          id: 2,
          value: "Major",
        },
        {
          id: 3,
          value: "OFI",
        },
        {
          id: 4,
          value: "Observation",
        },
      ],

      assigneeData: [
        {
          id: 1,
          name: "Nikhil Kapuganti",
        },
        {
          id: 2,
          name: "Abhiram Kadari",
        },
        {
          id: 3,
          name: "Venkatesh Abisetty",
        },
      ],
      oldComments: true,
      newHistory: true,
      comment: "",
      allEntities: [],
      presentFinding:[],
      comments: [],
      tabDataLoading:false,
      btnDisabled: true,
      showPopUp: false,
      findingsObject: {
        findingId: "",
        frameworks: "",
        frameWorkControl: "",
        findingCategory: "",
        findingComment: "",
        findingEvidence: "",
        auditResult: "",
      },
      taskObj: {},
      findingsObjectDummy: {},
      presentAuditData: {},
      selectedOption: "",
      selectedBG: "",
      workLogObject: [],
      optionsUserArray: [],
      orgUsersList: [],
      presentComplianceObject: {},
      tasksForAudit: [],
      presentTaskObject: {},
      personObj: "",
      controlsArray: [],
      controlDetailsArray: [],
      controlsArrayAllControls: [],
      controlsDetailsList: [],
      teamObj: "",
      selectedTabObj: {},
      users: [],
      allFrameWorkControls: [],
      locationObject: [],
      importpopUp: false,
      isInputFileNameValid: true,
      fileSelected: false,
      isFileValid: true,
      inputFileName: "",
      evidenceDate:'',
      evidenceAttachMode: 'file',
      evidenceUrl: '',
      linkSortKey: '',
      linkSortDir: 'asc',
      linkCurrentPage: 1,
      linkPageSize: 20,
      linkColumnNames: ['taskId', 'filename', 'url', 'evidenceDate'],
      linkColumnWidths: {},
      linkResizingColumn: null,
      linkResizeStartX: 0,
      linkResizeStartWidth: 0,
      linkDidResize: false,
      fileChanged: false,
      fileName: "",
      findingsForTask: [],
      allTasks: [],
      presentFindingTaskObj: {},
      linkEvidencePopup: false,
      linkEvidenceTasks: [],
      selectedExistingEvidences: [],
      existingEvidenceSortKey: '',
      existingEvidenceSortDir: 'asc',
      showExistingEvidenceFilters: false,
      existingEvidenceFilters: { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' },
      showDeleteEvidenceConfirm: false,
      deleteEvidenceIndex: null,
      showApprovalPopup: false,
      approvalObj: {},
      enableApproveAndReject : false,
      showRejectPopupForNormalApproval : false,
      showRejectPopupAtInReview : false,
      normalJustification:{
        justification : ''
      },
      finalJustification:{
        justification : ''
      },
      displayFormalapprovalButtons : false,
      showLoader: false,
      pdfValidation: false,
      clickOnButton: false,
      clickOnButtonAtAddingFile: false,
      clickOnButtonForNormal : false,
      clickOnButtonForFinal : false,
      newAssignee : '',
      placeholder: 'Select a File',
      previousStatus:''
    };
  },
  validations() {
    return {
      inputFileName: { required, restrictCharacters50 },
      fileToUpload: {
        required: requiredIf(function (this: any) {
          return this.evidenceAttachMode === 'file';
        })
      },
      evidenceUrl: {
        required: requiredIf(function (this: any) {
          return this.evidenceAttachMode === 'url';
        }),
        httpUrl
      },
      evidenceDate:{required},
      taskObj: {
        approver: {required},
        approvalComments: {required, restrictCharacters1000}
      },
      findingsObject: {
        findingId: { required },
        frameworks: { required },
        frameWorkControl: { required },
        findingCategory: { required },
        findingComment: { required },
        findingEvidence: { required },
        // auditResult: { required }
      },
      finalJustification:{
        justification : {restrictCharacters1000}
      },
      normalJustification:{
        justification : {restrictCharacters1000}
      },
    };
  },
  components: {
    breadCrumbs,
    popup,
    Multiselect,
    dotsLoader,
    // loader,
    commentsEditor,
    safeHtml,
    pagination,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    AutoComplete,
    Select
  },
  computed: {
    ...mapGetters({ userInfo: "userInfo",'dbPriority':'dbPriority','dbFrequency':'dbFrequency','dbBussiness':'dbBussiness','dbFinancial':'dbFinancial','dbOperations':'dbOperations','dbLegal':'dbLegal','dbLikelihood':'dbLikelihood','dbOverAllImpact':'dbOverAllImpact' }),
    currentFindingId(): any {
      return this.findingId || this.$route.params.findingId;
    },
    currentTaskId(): any {
      return this.taskId || this.$route.params.taskId;
    },
    todayDate() {
			return new Date().toISOString().split('T')[0];
		},
    isEvidenceSaveDisabled(): boolean {
      if (this.evidenceAttachMode === 'url') {
        return this.inputFileName.length === 0 && this.evidenceUrl.length === 0 && this.evidenceDate.length === 0;
      }
      return this.inputFileName.length === 0 && this.evidenceDate.length === 0;
    },
    fileEvidences(): any[] {
      const files = this.presentFindingTaskObj?.files;
      if (!Array.isArray(files)) return [];
      return files.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
    },
    linkEvidences(): any[] {
      const files = this.presentFindingTaskObj?.files;
      if (!Array.isArray(files)) return [];
      return files.filter((doc: any) => doc?.evidenceType === 'url');
    },
    findingDetailFileEvidences(): any[] {
      const files = this.findingDetails?.[0]?.files;
      if (!Array.isArray(files)) return [];
      return files.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
    },
    findingDetailLinkEvidences(): any[] {
      const files = this.findingDetails?.[0]?.files;
      if (!Array.isArray(files)) return [];
      return files.filter((doc: any) => doc?.evidenceType === 'url');
    },
    linkSortClass(): string {
      return this.linkSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
    },
    sortedLinkEvidences(): any[] {
      const rows = [...this.linkEvidences];
      const key = this.linkSortKey;
      if (!key) {
        return rows;
      }
      const dir = this.linkSortDir === 'asc' ? 1 : -1;
      return rows.sort((a: any, b: any) => {
        let aVal = '';
        let bVal = '';
        if (key === 'evidenceDate') {
          aVal = a?.evidenceDate || '';
          bVal = b?.evidenceDate || '';
        } else if (key === 'url') {
          aVal = a?.url || '';
          bVal = b?.url || '';
        } else if (key === 'taskId') {
          aVal = a?.taskId || '';
          bVal = b?.taskId || '';
        } else {
          aVal = a?.filename || a?.name || '';
          bVal = b?.filename || b?.name || '';
        }
        return String(aVal).localeCompare(String(bVal), undefined, { sensitivity: 'base' }) * dir;
      });
    },
    filteredLinkCount(): number {
      return this.sortedLinkEvidences.length;
    },
    paginatedLinkEvidences(): any[] {
      const start = (this.linkCurrentPage - 1) * this.linkPageSize;
      const end = this.linkCurrentPage * this.linkPageSize;
      return this.sortedLinkEvidences.slice(start, end);
    },
    pastYearExistingEvidences(): any[] {
      const currentId = String(this.currentTaskId || '');
      const currentUrls = new Set((this.presentFindingTaskObj?.files || []).map((doc: any) => doc?.url).filter((url: any) => !!url));
      const userId = String(this.userInfo?._id || '');
      const now = new Date();
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(now.getFullYear() - 1);
      const rows: any[] = [];
      (this.linkEvidenceTasks || []).forEach((task: any) => {
        if (String(task?._id || '') === currentId || !Array.isArray(task?.files)) return;
        const sourceTaskId = task.taskId != null && String(task.taskId) !== '' ? String(task.taskId) : '';
        if (!sourceTaskId) return;
        task.files.forEach((doc: any) => {
          if (!doc?.url || currentUrls.has(doc.url)) return;
          if (doc.taskId != null && String(doc.taskId) !== '' && String(doc.taskId) !== sourceTaskId) return;
          if (doc.linkedEvidenceTaskId != null && String(doc.linkedEvidenceTaskId) !== '') return;
          if (String(doc.createdBy || '') !== userId) return;
          const filename = doc.filename || doc.name;
          if (!filename) return;
          const evidenceTime = Date.parse(doc.evidenceDate);
          if (isNaN(evidenceTime) || evidenceTime < oneYearAgo.getTime() || evidenceTime > now.getTime()) return;
          rows.push({
            ...doc,
            filename,
            sourceTaskId,
            optionKey: `${sourceTaskId}|${doc.url}`
          });
        });
      });
      return rows;
    },
    existingEvidenceSortClass(): string {
      return this.existingEvidenceSortDir === 'asc' ? 'sort_desc' : 'sort_asc';
    },
    filteredSortedExistingEvidences(): any[] {
      const filters = this.existingEvidenceFilters || {};
      const rows = (this.pastYearExistingEvidences || []).filter((row: any) => {
        const title = String(row.filename || '').toLowerCase();
        const taskId = String(row.sourceTaskId || '').toLowerCase();
        const typeLabel = this.existingEvidenceTypeLabel(row).toLowerCase();
        if (filters.filename && !title.includes(String(filters.filename).toLowerCase())) return false;
        if (filters.sourceTaskId && !taskId.includes(String(filters.sourceTaskId).toLowerCase())) return false;
        if (filters.evidenceType && !typeLabel.includes(String(filters.evidenceType).toLowerCase())) return false;
        return true;
      });
      const key = this.existingEvidenceSortKey;
      if (!key) return rows;
      const modifier = this.existingEvidenceSortDir === 'desc' ? -1 : 1;
      return rows.sort((a: any, b: any) => {
        if (key === 'evidenceDate') {
          const aTime = Date.parse(a?.evidenceDate);
          const bTime = Date.parse(b?.evidenceDate);
          if (aTime < bTime) return -1 * modifier;
          if (aTime > bTime) return 1 * modifier;
          return 0;
        }
        if (key === 'sourceTaskId') {
          const aVal = String(a?.sourceTaskId || '');
          const bVal = String(b?.sourceTaskId || '');
          const aNumMatch = aVal.match(/\d+$/);
          const bNumMatch = bVal.match(/\d+$/);
          if (aNumMatch && bNumMatch) {
            const aNum = parseInt(aNumMatch[0], 10);
            const bNum = parseInt(bNumMatch[0], 10);
            if (aNum < bNum) return -1 * modifier;
            if (aNum > bNum) return 1 * modifier;
            return 0;
          }
          if (aVal < bVal) return -1 * modifier;
          if (aVal > bVal) return 1 * modifier;
          return 0;
        }
        const aVal = key === 'evidenceType' ? this.existingEvidenceTypeLabel(a) : String(a?.filename || '');
        const bVal = key === 'evidenceType' ? this.existingEvidenceTypeLabel(b) : String(b?.filename || '');
        if (aVal.toLowerCase() < bVal.toLowerCase()) return -1 * modifier;
        if (aVal.toLowerCase() > bVal.toLowerCase()) return 1 * modifier;
        return 0;
      });
    },
    linkTableResizeStyle(): any {
      return {
        tableLayout: 'fixed',
        width: '100%',
        maxWidth: '100%',
      };
    },
  },
  methods: {
     getLocationNameForSystem(dept:any){      
    if(dept!=undefined){
      let d = this.allEntities.find((Dept:any)=>Dept.departments && Dept.departments.includes(dept));
      return d ? d.entityDisplayName : 'N/A'
      
    }
     const matched = this.locationObject.find((obj: any) => obj.entityType === 1);
      return matched ? matched.label : 'N/A';
  },
    clearSelectedFile() {
      this.fileName = '';
      this.fileToUpload = '';
      this.pdfValidation = false;
      this.v$.$reset();

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    onDragOver() {
      this.isDragOver = true;
    },

    onDragLeave() {
      this.isDragOver = false;
    },

    onFileDrop(event:any) {
      this.isDragOver = false;
      const file = event.dataTransfer?.files?.[0];
      if (file) {
        this.applySelectedFile(file);
      }
    },

    handleFileUpload(event:any) {
      const file = event?.target?.files?.[0];
      if (file) {
        this.applySelectedFile(file);
      } else {
        this.fileName = '';
        this.inputFileName = '';
      }
    },
    applySelectedFile(file:any) {
      this.fileName = file.name;
      this.fileToUpload = file;

      const fileNameParts = file.name.split('.');
      fileNameParts.pop();
      const nameWithoutExtension = fileNameParts.join('.');
      if (this.inputFileName.trim() === '') {
        this.inputFileName = nameWithoutExtension;
      }
      // const fileExtension = file.name.split('.').pop();
      const fileExtension = file.name.split('.').pop()?.toLowerCase();
      if (
        fileExtension == 'pdf' || fileExtension == 'docx' || fileExtension == 'xls' ||
        fileExtension == 'xlsx' || fileExtension == 'jpeg' || fileExtension == 'png' ||
        fileExtension == 'jpg' || fileExtension == 'mp4' || fileExtension == 'doc' ||
        fileExtension == 'rtf' || fileExtension == 'txt' || fileExtension == 'csv' ||
        fileExtension == 'zip' || fileExtension == 'ods'
      ) {
        this.pdfValidation = false;
        this.v$.$reset();
      } else {
        this.pdfValidation = true;
      }
    },
    shouldStyleDueDate(row:any) {
        const status = row.taskStatus ?? row.statusCode;
        return status != 10403 && status != 10418;
    },
    colorForDueDate(date: any) {
      if (!date) return '';
      const due = new Date(date);
      if (isNaN(due.getTime())) return '';
      const today = new Date();
      due.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (due < today) {
        return ["bgdarkred border-solid border text-darkred font-semibold flex justify-center items-center text-xs"]
      }
      return '';
    },
   colorLabelText(value: any) {
      if (value == 1) {
          return ["text-lightgreen font-semibold"];
      } else if (value == 2) {
          return ["text-green font-semibold"];
      } else if (value == 3) {
          return ["text-yellow font-semibold"];
      } else if (value == 4) {
          return ["text-error font-semibold"];
      } else if (value == 5) {
          return ["text-darkred font-semibold"];
      }
    },
  colorLabelBg(value: any) {
      if (value == 1) {
          return ["bg-veryLowColor border-solid border border-lightgreen"];
      } else if (value == 2) {
          return ["bg-lowColor border-solid border border-green"];
      } else if (value == 3) {
          return ["bg-moderateColor border-solid border border-yellow"];
      } else if (value == 4) {
          return ["bg-highColor border-solid border border-error"];
      } else if (value == 5) {
          return ["bg-veryHighColor border-solid border border-darkred"];
      }
    },
  getFindingSeverityValue(obj: any) {
      const raw = obj?.finding_severity ?? obj?.findingSeverity;
      if (raw == null || raw === '') return null;
      if (typeof raw === 'object') {
        return raw.value != null && raw.value !== '' ? Number(raw.value) : null;
      }
      const numeric = Number(raw);
      return Number.isFinite(numeric) ? numeric : null;
    },
  getFindingSeverityLabel(obj: any) {
      const raw = obj?.finding_severity ?? obj?.findingSeverity;
      if (raw == null || raw === '') return 'N/A';
      if (typeof raw === 'object' && raw.label != null && String(raw.label).trim() !== '') {
        return String(raw.label);
      }
      return 'N/A';
    },
  isDisabledFindingSeverityLabel(label: any) {
      const text = String(label || '').trim().toUpperCase();
      return text === 'N/A' || text === 'NONE';
    },
  findingSeverityChipBg(obj: any) {
      const label = this.getFindingSeverityLabel(obj);
      if (this.isDisabledFindingSeverityLabel(label)) {
        return ['bg-lightgrey border-solid border border-lightgrey'];
      }
      const value = this.getFindingSeverityValue(obj);
      if (value == 1) return ['bgLightGreen border-solid border border-lightgreen'];
      if (value == 2) return ['bgGreen border-solid border border-green'];
      if (value == 3) return ['bgYellow border-solid border border-yellow'];
      if (value == 4) return ['bgError border-solid border border-error'];
      if (value == 5) return ['bgdarkred border-solid border border-darkred'];
      return ['bg-lightgrey border-solid border border-lightgrey'];
    },
  findingSeverityChipText(obj: any) {
      const label = this.getFindingSeverityLabel(obj);
      if (this.isDisabledFindingSeverityLabel(label)) {
        return ['text-gray text-xs font-semibold'];
      }
      const value = this.getFindingSeverityValue(obj);
      if (value == 1) return ['text-lightgreen text-xs font-semibold'];
      if (value == 2) return ['text-green text-xs font-semibold'];
      if (value == 3) return ['text-yellow text-xs font-semibold'];
      if (value == 4) return ['text-error text-xs font-semibold'];
      if (value == 5) return ['text-darkred text-xs font-semibold'];
      return ['text-gray text-xs font-semibold'];
    },
    getProirityLabel(val:any){
      if (val === 'N/A') { 
          return ''; 
      } else {
        let a = this.dbPriority.find((obj: any) => obj.value == val);
        return (val && typeof val === 'number') ? a.key : '';
      }
    },
    getFindingRelatedToFieldLabel(obj: any) {
      if (!obj || obj.findingRelatedTo == null || obj.findingRelatedTo === '') {
        return 'CID / KPI ID';
      }
      return Number(obj.findingRelatedTo) === 2 ? 'KPI ID' : 'CID';
    },
    getFindingRelatedToDisplay(obj: any) {
      if (!obj || obj.findingRelatedTo == null || obj.findingRelatedTo === '') {
        return 'N/A';
      }
      if (Number(obj.findingRelatedTo) === 2) {
        // Prefer enriched human-readable KPI ID (kpi.kpi_id), then resolve from task kpis
        if (obj.findingRelatedToLabel && String(obj.findingRelatedToLabel).trim() !== '' && obj.findingRelatedToLabel !== 'N/A') {
          return String(obj.findingRelatedToLabel);
        }
        const kpiRef = obj.kpi_id ?? obj['kpi._id'] ?? obj.kpi?._id ?? obj.controlorKpi;
        const kpis = obj?.complianceDetails?.[0]?.kpis || obj?.kpis || [];
        if (kpiRef != null && Array.isArray(kpis) && kpis.length) {
          const matched = kpis.find(
            (k: any) =>
              k._id == kpiRef ||
              k._id?.toString() === String(kpiRef) ||
              String(k.kpi_id) === String(kpiRef)
          );
          if (matched?.kpi_id != null && String(matched.kpi_id).trim() !== '') {
            return String(matched.kpi_id);
          }
        }
        return kpiRef != null && String(kpiRef).trim() !== '' ? String(kpiRef) : 'N/A';
      }
      const clientUniqueId =
        obj?.clientUniqueId ??
        obj?.complianceDetails?.[0]?.clientUniqueId;
      return clientUniqueId != null && String(clientUniqueId).trim() !== ''
        ? String(clientUniqueId)
        : 'N/A';
    },
    getFindingLinkFieldLabel(obj: any) {
      if (!obj) {
        return 'Control / KPI';
      }
      if (obj.linkFieldLabel) {
        return obj.linkFieldLabel;
      }
      if (obj.findingRelatedTo == null || obj.findingRelatedTo === '') {
        return 'Control / KPI';
      }
      return Number(obj.findingRelatedTo) === 2 ? 'KPI' : 'Control';
    },
    getFindingLinkDisplay(obj: any) {
      if (!obj) {
        return 'N/A';
      }
      if (obj.linkDisplay) {
        return obj.linkDisplay;
      }
      if (obj.findingRelatedTo == null || obj.findingRelatedTo === '') {
        return 'N/A';
      }
      if (Number(obj.findingRelatedTo) === 2) {
        return 'N/A';
      }
      return obj.controlTitle || 'N/A';
    },
     getRiskOwnerLabel(userId:any) {

			const user = this.optionsUserArray.find(
				(u: any) => u.value === userId
			);

			return user ? user.label : 'N/A';
		},
     bgColor(value: any) {
          if (value == 1) {
              return ['bg-veryLowColor border-solid border border-lightgreen'];
          } else if (value == 2) {
              return ['bg-lowColor border-solid border border-green'];
          } else if (value == 3) {
              return ['bg-moderateColor border-solid border border-yellow'];
          } else if (value == 4) {
              return ['bg-highColor border-solid border border-error'];
          } else if (value == 5) {
              return ['bg-veryHighColor border-solid border border-darkred'];
          }
      },
    colorLabel(value: any) {
          if (value == 1) {
              return ['text-lightgreen font-semibold text-xs'];
          } else if (value == 2) {
              return ['text-green font-semibold text-xs'];
          } else if (value == 3) {
              return ['text-yellow font-semibold text-xs'];
          } else if (value == 4) {
              return ['text-error font-semibold text-xs'];
          } else if (value == 5) {
              return ['text-darkred font-semibold text-xs'];
          }
      },
    	getLablesInfo(data:any,id:any){
			if(id==1){
				let a = this.dbBussiness.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==2){
				let a = this.dbFinancial.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==3){
				let a = this.dbOperations.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==4){
				let a = this.dbLegal.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}if(id==5){
				let a = this.dbLikelihood.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==6){
				let a = this.dbOverAllImpact.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
		},
     treatmentSummaryData(actionType:any){
    if(actionType!='' && actionType==10424){
				if(this.riskInformationArray.transferSummary && this.riskInformationArray.transferSummary!=undefined){
					return this.riskInformationArray.transferSummary
				}
				else{
					return 'N/A'
				}
			}
			else if(actionType!='' && actionType==10419){
				if(this.riskInformationArray.avoidSummary && this.riskInformationArray.avoidSummary!=undefined){
					return this.riskInformationArray.avoidSummary
				}
				else{
					return 'N/A'
				}
			}
			else if(actionType!='' && actionType==10403){
				if(this.riskInformationArray.acceptSummary && this.riskInformationArray.acceptSummary!=undefined){
					return this.riskInformationArray.acceptSummary
				}
				else{
					return 'N/A'
				}
			}
      else if(actionType!='' && actionType==10425){
        if(this.riskInformationArray.moniteredSummary && this.riskInformationArray.moniteredSummary!=undefined){
					return this.riskInformationArray.moniteredSummary
        }
        else{
          return 'N/A'
        }
			}
			else{
				return 'N/A'
			}
			
		},
  async getPresentFindingObject() {
      const result = await this.$http.get(
        `${process.env.VUE_APP_MONITOR_API}/api/org/finding/${this.currentFindingId}/get`
      );
      this.presentFinding=result.data
      this.findingDetails = [];
      for (var i = 0; i < this.presentFinding.length; i++) {
        this.findingDetails.push({
          id: this.presentFinding[i].findingId,
          name: this.presentFinding[i].finding,
          files:this.presentFinding[i].files,
          findingRelatedTo: this.presentFinding[i].findingRelatedTo,
          findingRelatedToLabel: this.presentFinding[i].findingRelatedToLabel,
          linkFieldLabel: this.presentFinding[i].linkFieldLabel,
          linkDisplay: this.presentFinding[i].linkDisplay,
          control_id: this.presentFinding[i].control_id,
          kpi_id: this.presentFinding[i].kpi_id,
          finding_severity: this.presentFinding[i].finding_severity ?? this.presentFinding[i].findingSeverity,
          clientUniqueId: this.presentFinding[i]?.complianceDetails?.[0]?.clientUniqueId,
          controlTitle: this.presentFinding[i]?.complianceDetails?.[0]?.controlTitle,
        });
      }
  },
    treatmentTypeBgColor(id:any){
			if(id==10403){
				return ["bg-veryLowColor border-solid border border-lightgreen"];
			}
			else if(id ==10419){
				 return ["bg-lowColor border-solid border border-green"];
			}
			else if(id==10405){
				return  ['bg-veryLowColor border-solid border border-lightgreen'];
			}
			else if(id==10424){
				return ["bg-moderateColor border-solid border border-yellow"];
			}
      else if(id==10425){
				return ["bg-resetBlue/10 border-solid border border-resetBlue"];
			}
		},
    treatmentTypeTextColor(id:any){
			if(id==10403){
				return ["text-lightgreen font-semibold"];
			}
			else if(id ==10419){
				  return ["text-green font-semibold"];
			}
			else if(id ==10405){
				return ['text-lightgreen font-semibold'];
			}
			else if(id==10424){
				return ["text-yellow font-semibold"];
			}
      else if(id==10425){
				return ["text-resetBlue font-semibold"];
			}
		},
    presentTask(dataInfo: any) {
      const item = this.treatmentTypeStatus.find((data: any) => data.id == dataInfo);
      return item ? item.label : 'N/A';
    },
  openCalendar(event: any) {
    event.target.showPicker();
  },
  async getCapaStatuses(){
    let appId='10001';
    let entityId='10119';

    await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`)
    .then((result: any) => {				
        
        const allStatuses = result.data.statuses;

        this.taskStatusInfo = allStatuses
          .filter((item:any) => [10401, 10402, 10408, 10414].includes(item.id))
          .map((item:any) => ({
            id: item.id,
            value: item.label
          }));

        this.reviewerTask = allStatuses
          .filter((item:any) => [10414, 10421].includes(item.id))
          .map((item:any) => ({
            id: item.id,
            value: item.label
          }));
          this.treatmentTypeStatus=result.data.treatmentTypes


    });
},
    formatFileAttachedTime(time: any) {    
      let now = moment(time);
      return now.format("DD-MM-YYYY");
    },
    getEntity(id :any){
      let entity:any
      if(id=='Global'){
        return 'Global'
      }
      else if(id != undefined || id != null){
        entity = this.allEntities.find((data:any)=> { return data._id == id})
        if(entity != undefined){
          return entity.entityName
        } else {
          return 'N/A'
        }
      } else {
        return 'N/A'
      }
    },
    filterTaskStatusData(data: any) {
      const startId = 10414;
      const endId = 10403;
      return data.filter((item: any) => item.id >= startId && item.id <= endId);
    },
    asyncFind(query: any) {
      query=query.query.trim();
      if (query == "") {
        this.userOptions = [];
      } else if (query.length >= 1) {
        this.userOptions = this.optionsUserArray.filter((obj: any) => {
          if(obj.value != this.presentFindingTaskObj.reviewer){
            return obj.label.toLowerCase().includes(query.toLowerCase());
          }
        });
      }
    },
    asyncApproverFind(query: any) {
      query=query.query.trim();
      if (query == "") {
        this.userOptions = [];
      } else if (query.length >= 1) {
        this.userOptions = this.optionsUserArray.filter((obj: any) => { 
          if(obj.value == this.presentFindingTaskObj.reviewer && obj.value != this.userInfo._id){
            return obj.label.toLowerCase().includes(query.toLowerCase());
          }
        });
      }
    },
    getEntityName(entityName:any){      
      if(entityName=='Global'){
        
        let Entity = this.locationObject.find((loc:any)=>loc.entityType==1)
        return Entity?.label||'N/A';
      }
      return entityName; 
    },
    openApprovalpopup() {
      this.showApprovalPopup = true;
    },
    onCrossbtn() {
      this.showApprovalPopup = false;
      this.v$.$reset(); 
      this.taskObj = {};
      // this.taskObj.approvalComments = '';
    },
    clickToRejectByJustification(){
      this.showRejectPopupForNormalApproval = true;
    },
    onClickToRejectByJustificationAtInReview(){
      this.showRejectPopupAtInReview = true;
    },
    onCrossBtnForNormalApproval(){
      this.showRejectPopupForNormalApproval = false;
      this.normalJustification.justification = '';
    },
    onCrossBtnForFinalApproval(){
      this.showRejectPopupAtInReview = false;
      this.finalJustification.justification = '';
    },
    onCancelbtnForNormalApproval(){
      this.onCrossBtnForNormalApproval();
    },
    onCancelbtnForFinalApproval(){
      this.onCrossBtnForFinalApproval();
    },
    async ApprovalforInprogress(statusCode: any) {
      this.clickOnButtonForNormal = true;
      const payload: any = {
        statusCode: statusCode,
        rejectJustification : this.normalJustification?.justification ,
        updatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
        updatedBy: this.userInfo._id,
      };
     try{
       await this.$http
        .post(
          `${process.env.VUE_APP_MONITOR_API}/api/org/control/task/${this.currentTaskId}/update/approval`,
          payload
        )
        .then((result: { data: any }) => {
			if (statusCode == 10403) {
				toast.info(`Approval Approved`, {
				timeout: 1000,
				closeOnClick: true,
				closeButton: "button",
				icon: true,
				})

			} else if(statusCode == 10410){
				toast.info(`Approval Rejected`, {
					timeout: 1000,
					closeOnClick: true,
					closeButton: "button",
					icon: true
				});
			}
      this.enableApproveAndReject = false
        });
     }catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			} finally {
				this.clickOnButtonForNormal = false;
			}
        await this.getAllFindingTasks();
        await this.getFindingTaskHistoryObject()
        this.onCrossBtnForNormalApproval()
    },
    onCancelbtnAtApproval() {
      // this.showModal = false;
			this.v$.$reset();
			this.showBlock = false;
      this.taskObj = {}
		},
    async applyAuthority() {
      this.v$.$touch();
			if (!this.v$.taskObj.$invalid) {
        this.clickOnButton = true;
        let dummyTaskObj:any = _.cloneDeep(this.taskObj);
        this.enableApproveAndReject = true
        this.showApprovalPopup = false;
        const payload: any = {
          approver: dummyTaskObj.approver.value ? dummyTaskObj.approver.value: dummyTaskObj.approver,
          comments: dummyTaskObj.approvalComments
        };
        // 			{
        //     "assignee": 64ca27ca3c8058400c9f7a68,
        //     "comments": "justification message",
        //     "created By": "64ca27ca3c8058400c9f7a68",
        //     "createdAt": "2024-07-03 12:17:46"
        // }
        await this.updateFindingTask(8, payload);
        await this.getAllFindingTasks();
        await this.getFindingTaskHistoryObject()
        dummyTaskObj = {};
      }
    },
    checkKey(obj: any, key: any) {
      if (obj == "" || obj == undefined) {
        return false;
      } else {
        const keys: any = Object.keys(obj);
        for (let i = 0; i < keys.length; i++) {
          if (keys[i] === key) {
            return true;
          }
        }
        return false;
      }
    },
    async approveOrRejectForActionTasktoComplete(statusCode: any, typeId: any) {
      this.clickOnButtonForFinal = true;
      const payload: any = {
        action: 10302,
        statusCode: statusCode,
        createdAt: moment().format("YYYY-MM-DD HH:mm:ss"),
        createdBy: this.userInfo._id,
      };
      try{
        await this.$http
        .post(
          `${process.env.VUE_APP_MONITOR_API}/capa/task/${this.currentTaskId}/type/${typeId}/update`,
          payload
        )
        .then((result: { data: any }) => {
        });
      if (statusCode == 10403) {
        toast.info(`Approval Approved`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
        // const workflowpayload = [
        //   {
        //     findingId: this.currentFindingId,
        //     createdBy: this.userInfo._id,
        //     createdAt: moment().format("YYYY-MM-DD HH:mm:ss"),
        //   },
        // ];
        // await this.$http
        //   .post(
        //     `${process.env.VUE_APP_WORKFLOW_API_URL}/api/org/trigger/workflow/${process.env.VUE_APP_WORKFLOW_ID}/compliance/findings/task`,
        //     workflowpayload
        //   )
        //   .then((result: { data: any }) => {
        //   });
      } else if (statusCode == 10401) {
        toast.info(`Approval Rejected`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
        if(this.disabledStatuses && this.disabledStatuses.length>0) {                  
            this.disabledStatuses = [];
        }
      }
      }catch (e:any) {
        if(e.response.status==403){
              toast.error(`${e.response.data.error}`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: 'button',
              icon: true
            });
          }
          else {
            toast.error('error', {
            timeout: 1000,
            closeOnClick: true,
            closeButton: 'button',
            icon: true
          });
          }
				
			} finally {
				this.clickOnButtonForFinal = false;
			}
      await this.getFindingTaskHistoryObject();
      await this.getAllFindingTasks();
      this.onCrossBtnForFinalApproval();
    },
    async getFindingTaskHistoryObject() {
      let taskId = this.currentTaskId;
      // /api/org/task/:taskId/getHistory
      await this.$http
        .get(
          `${process.env.VUE_APP_MONITOR_API}/capa/task/${taskId}/history`
        )
        .then((result: any) => {
          const mainObject = result.data;
          this.workLogObject = mainObject;
        });
        this.workLogObject.taskHistory?.sort().reverse();
    },

    getCategory(num: any) {
      let result = this.findingCategoryData.find((obj: any) => {
        return obj.id == num;
      });
      return result.value;
    },
    getDeptEntity(teamId: any) {
      let presentteamObject: any = this.users.find((obj: any) => {
        return obj._id == teamId;
      });
      if (presentteamObject != undefined && presentteamObject.entityType == 20301) {
        // let entityObj = this.allEntities.find((entity: any)=>{return entity.entityType == 1})
        return presentteamObject ? presentteamObject.entityName : 'N/A';
      } else if(presentteamObject != undefined && presentteamObject.entityType == 20303){
        return presentteamObject ? presentteamObject.entityDisplayName : 'N/A';
      } else {
        return 'N/A'
      }
    },
    getLocation(teamId: any) {
      let presentteamObject: any = this.users.find((obj: any) => {
        return obj._id == teamId;
      });

      if (presentteamObject != undefined && presentteamObject.type == 20301) {
        let entityObj = this.allEntities.find((entity: any) => {
          return entity.entityType == 1;
        });
        return entityObj ? entityObj.entityName : 'N/A';
      } else {
        if (
          this.presentTaskObject.location == undefined ||
          this.presentTaskObject.location == null
        ) {
          return "N/A";
        } else {
          return this.getLocationName(
            this.presentTaskObject.location[0].entity
          );
        }
      }
    },
    getLocationName(locationId: any) {
      if(locationId == 'global'){
        return this.locationObject.find((l:any)=>l.entityType==1)?.label||'N/A'
      }else if (locationId == null){ return 'N/A'}
      else{
          let locationObj = this.locationObject.find((obj: any) => {
            return obj.value == locationId;
          });
          if (locationObj == undefined) {
            let empty = "";
            return empty;
          } else {
            return locationObj?.label;
          }
      }
    },
    onCancelIcon() {
      this.resetEvidenceForm();
      this.importpopUp = false;
    },
    resetEvidenceForm() {
      this.inputFileName = "";
      this.fileName = "";
      this.fileToUpload = '';
      this.evidenceDate = "";
      this.evidenceUrl = '';
      this.evidenceAttachMode = 'file';
      this.pdfValidation = false;
      this.v$.$reset();
    },
    resetLinkPagination() {
      this.linkCurrentPage = 1;
    },
    onLinkPaginationUpdate(currentPage: any, pageSize: any) {
      this.linkCurrentPage = currentPage;
      this.linkPageSize = pageSize;
    },
    linkColumnStyle(column: string) {
      const width = this.linkColumnWidths[column];
      if (!width) {
        return {};
      }
      return {
        width: width + 'px',
        minWidth: '60px',
        maxWidth: width + 'px',
      };
    },
    snapshotLinkColumnWidths() {
      const headers = this.$el?.querySelectorAll?.('.evidence-links-header thead th') || [];
      const names = this.linkColumnNames || [];
      headers.forEach((th: HTMLElement, index: number) => {
        const column = names[index];
        if (column && this.linkColumnWidths[column] == null) {
          this.linkColumnWidths[column] = Math.round(th.getBoundingClientRect().width);
        }
      });
    },
    getLinkContainerWidth() {
      const container = this.$el?.querySelector?.('.evidence-links-scroll') as HTMLElement | null;
      if (container) {
        return Math.max(60, Math.floor(container.clientWidth || container.getBoundingClientRect().width));
      }
      return window.innerWidth;
    },
    maxWidthForLinkColumn(column: string, proposedWidth: number) {
      const names = this.linkColumnNames || [];
      const otherWidth = names.reduce((sum: number, name: string) => {
        if (name === column) {
          return sum;
        }
        return sum + (Number(this.linkColumnWidths[name]) || 60);
      }, 0);
      const containerWidth = this.getLinkContainerWidth();
      const maxTotal = Math.max(60, containerWidth - otherWidth);
      return Math.min(proposedWidth, maxTotal, containerWidth);
    },
    clampLinkWidthsToContainer() {
      const names = this.linkColumnNames || [];
      if (!names.length || !Object.keys(this.linkColumnWidths || {}).length) {
        return;
      }
      const containerWidth = this.getLinkContainerWidth();
      const total = names.reduce((sum: number, name: string) => sum + (Number(this.linkColumnWidths[name]) || 0), 0);
      if (total <= containerWidth) {
        return;
      }
      const scale = containerWidth / total;
      const next: Record<string, number> = { ...this.linkColumnWidths };
      names.forEach((name: string) => {
        if (next[name]) {
          next[name] = Math.max(60, Math.round(next[name] * scale));
        }
      });
      let overflow = names.reduce((sum: number, name: string) => sum + (Number(next[name]) || 0), 0) - containerWidth;
      for (let i = names.length - 1; i >= 0 && overflow > 0; i--) {
        const name = names[i];
        const current = Number(next[name]) || 0;
        if (current > 60) {
          const reduced = Math.max(60, current - overflow);
          overflow -= current - reduced;
          next[name] = reduced;
        }
      }
      this.linkColumnWidths = next;
    },
    startLinkColumnResize(event: MouseEvent, column: string) {
      this.snapshotLinkColumnWidths();
      this.clampLinkWidthsToContainer();
      const th = (event.currentTarget as HTMLElement)?.closest('th');
      this.linkResizingColumn = column;
      this.linkResizeStartX = event.clientX;
      this.linkResizeStartWidth = this.linkColumnWidths[column] || th?.getBoundingClientRect().width || 60;
      this.linkDidResize = false;
      document.body.classList.add('col-resizing');
      document.addEventListener('mousemove', this.onLinkColumnResize);
      document.addEventListener('mouseup', this.stopLinkColumnResize);
    },
    onLinkColumnResize(event: MouseEvent) {
      if (!this.linkResizingColumn) {
        return;
      }
      const delta = event.clientX - this.linkResizeStartX;
      if (Math.abs(delta) > 2) {
        this.linkDidResize = true;
      }
      const nextWidth = this.maxWidthForLinkColumn(
        this.linkResizingColumn,
        Math.max(60, Math.round(this.linkResizeStartWidth + delta))
      );
      this.linkColumnWidths = { ...this.linkColumnWidths, [this.linkResizingColumn]: nextWidth };
    },
    stopLinkColumnResize() {
      this.linkResizingColumn = null;
      document.body.classList.remove('col-resizing');
      document.removeEventListener('mousemove', this.onLinkColumnResize);
      document.removeEventListener('mouseup', this.stopLinkColumnResize);
    },
    onLinkHeaderClick(column: string) {
      if (this.linkDidResize) {
        this.linkDidResize = false;
        return;
      }
      this.sortLinkEvidences(column);
    },
    sortLinkEvidences(key: string) {
      if (this.linkSortKey === key) {
        this.linkSortDir = this.linkSortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.linkSortKey = key;
        this.linkSortDir = 'asc';
      }
      this.resetLinkPagination();
    },
    getEvidenceFileExt(doc: any) {
      if (!doc?.url || doc.evidenceType === 'url') return '';
      try {
        const path = new URL(doc.url).pathname;
        return (path.split('.').pop() || '').toLowerCase();
      } catch {
        return (String(doc.url).split('.').pop() || '').toLowerCase();
      }
    },
    getStatusLabel(num: any) {
      // let result = this.taskStatusData.find((obj: any) => {
      //   return obj.id == num;
      // });
      // if (result != null || result != undefined) {
      //   return result.value;
      // }
      if(num==10403){
        return 'Completed';
      }
      if(num == 10421 || num == 10403){
          let result = this.reviewerTask.find((obj:any)=>{return obj.id == num})
          if(result != null || result != undefined){
              return result.value
          }
      }
			let result = this.taskStatusInfo.find((obj:any)=>{return obj.id == num})
			if(result != null || result != undefined){
          return result.value
      }
    },
    scrollTabIntoView(tabId: any) {
      this.$nextTick(() => {
        const tabElement = this.$el.querySelector(`.tab:nth-child(${tabId})`);
        if (tabElement) {
          tabElement.scrollIntoView({ behavior: "smooth", inline: "center" });
        }
      });
    },
    getTeamName(team: any) {
      let teamObj = this.users.find((obj: any) => {
        return obj._id == team;
      });
      if (teamObj == undefined) {
        return "";
      } else {
        return teamObj.displayName;
      }
    },
    colorFindingBg(status: any) {
            if (status == 10401) {
                return ['bgDisabledGrey border-solid border border-disabledgrey'];
            } else if (status == 10421) {
                return ['bgYellow border-solid border border-yellow'];
            } else if (status == 10403) {
                return ['bgLightGreen border-solid border border-lightgreen'];
            } else if (status == 10414) {
                return ['bgElectricGreen border-solid border border-electricGreen'];
            } else if (status == 10402 ) {
                return ['bgElectricGreen border-solid border border-electricGreen'];
            } else if (status == 10408) {
                return ['bgPrimary border-solid border border-primary'];
            } else if (status == 10414) {
                return ['bgForReview border-solid border border-forReview'];
            }
        },
        colorFindingText(status: any) {
            if (status == 10401) {
                return ['font-semibold text-xs text-disabledgrey'];
            } else if (status == 10421 ) {
                return ['font-semibold text-xs text-yellow'];
            } else if (status == 10403) {
                return ['font-semibold text-xs text-lightgreen'];
            } else if(status == 10414){
                return ['font-semibold text-xs mx-2 text-electricGreen']
            } else if (status == 10402 ) {
                return ['font-semibold text-xs text-electricGreen'];
            } else if(status == 10408){
                return ['font-semibold text-xs mx-2 text-primary']
            } else if(status == 10414){
				        return ['font-semibold text-xs mx-2 text-forReview']
			}
        },
      checkreviewer() {
      if (this.presentFindingTaskObj.reviewer == this.userInfo._id &&( this.userInfo.role_id==10215 && this.userInfo.roleId==10215)) {
        return true;
      }else if (((this.userInfo.role_id!=10217&& this.userInfo.role_id!=10217 || this.userInfo.roleId!=10217&& this.userInfo.roleId!=10217)) && this.presentFindingTaskObj.statusCode==10401 ) {
        return false;
      }
      else if (((this.userInfo.role_id!=10217&& this.userInfo.role_id!=10217 || this.userInfo.roleId!=10217&& this.userInfo.roleId!=10217))  && this.presentFindingTaskObj.statusCode==10414 ) {
        return true;
      }
      else if (
        this.presentFindingTaskObj.reviewer == undefined ||
        this.presentFindingTaskObj.reviewer == null
      ) {
        return "-";
      } else {
        return false;
      }
    },
    async getallUsers() {
      await this.$http
        .get(`${process.env.VUE_APP_ORG_API}/users/getAll`)
        .then((res: any) => {
          this.orgUsersList = res.data;
          for (var i = 0; i < this.orgUsersList.length; i++) {
            // if (this.orgUsersList[i].isActive == true) {
              this.optionsUserArray.push({
                label: this.orgUsersList[i].name,
                value: this.orgUsersList[i]._id,
              });
            // }
          }
        });
    },
    async getallEntities() {
      this.locationObject = [];
      let result: any;
      await this.$http
        .get(
          `${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`
        )
        .then((res: any) => {
          result = res.data;
          this.allEntities = res.data;
        });
      for (var i = 0; i < result.length; i++) {
        this.locationObject.push({
          label: result[i].entityDisplayName,
          value: result[i]._id,
          entityType:result[i].entityType
        });
      }
    },
    async getAllTeams() {
      this.teamObject = [];
      await this.$http
        .get(`${process.env.VUE_APP_ORG_API}/departments/get`)
        .then((res: any) => {
          this.users = res.data;
        });
      for (var i = 0; i < this.users.length; i++) {
        this.teamObject.push({
          label: this.users[i].teamName,
          value: this.users[i]._id,
        });
      }
    },
    isAddDisabled(permission:any) {
      try {
				if (!this.userInfo || !this.userInfo.organisationType) {
					return true;  
				}
        // if (this.userInfo.organisationType !== 10701) {
        //     return true;
        // }
        return this.hasPermission(this.userInfo, 10001, 10119, permission);
      } catch (e) {
          return true;
      }
	  },
    hasPermission(userInfo:any, appId:any, entityId:any, permissionId:any) {
      if (!userInfo || !userInfo.apps) return false;

      const app = userInfo.apps.find((a:any) => a.appId === appId);
      if (!app) return false;      

      const entity = app.entities?.find((e:any) => e.entityId === entityId);
      if (!entity) return false;

      return entity.permissions?.includes(permissionId) || false;
	  },
    getPersonName(person: any) {
			let personObj = this.orgUsersList.find((user: any) => {
				return user._id == person;
			});
			if (personObj == undefined && person==undefined) {
				return '';
			} else if(person!=undefined && personObj==undefined){								
				if(this.userInfo._id==person){					
					return this.userInfo.name;
				}
				else{
					return '';
				}
			}else {
				return personObj.name;
			}
		},
    getPerson(person: any) {
      this.personObj = this.orgUsersList.find((user: any) => {
        return user._id == person;
      });
      if (this.personObj == undefined) {
        return "";
      } else {
        return this.personObj.name;
      }
    },
    sortWorkLog() {
      this.newHistory = !this.newHistory;
      this.workLogObject.taskHistory.sort().reverse();
    },
    sortComments() {
      this.oldComments = !this.oldComments;
      if(this.presentFindingTaskObj.comments != undefined && this.presentFindingTaskObj.comments.length != 0){
        this.presentFindingTaskObj.comments.sort().reverse();
      }
    },
    formatTime(time: any) {
      let now = moment(time);
      return now.format("DD-MM-YYYY, HH:mm:ss");
    },
    formatDate(time: any) {
      if(time!=undefined){
        return moment(time).format("DD-MM-YYYY");
      }
      else{
        return 'N/A'
      }
    },
    extractInitials(name: any) {
      const names = name.split(" ");
      return names
        .map((name: any) => name[0])
        .join("")
        .toUpperCase();
    },
    changeBackground() {
      if (this.TaskDetailsDropDown.taskStatus == 10401) {
        return "bg-disabledgrey textColorWhite";
      }else if (this.TaskDetailsDropDown.taskStatus == 10418) {
        return "bg-error textColorWhite";
      }   else if (this.TaskDetailsDropDown.taskStatus == 10421) {
        return "bg-yellow textColorWhite";
      } else if (this.TaskDetailsDropDown.taskStatus == 10402) {
        return "bg-electricGreen textColorWhite";
      } else if (this.TaskDetailsDropDown.taskStatus == 10408) {
        return "bg-primary textColorWhite";
      } else if (this.TaskDetailsDropDown.taskStatus == 10403) {
        return "bg-lightgreen textColorWhite";
      } else if (this.TaskDetailsDropDown.taskStatus == 10417) {
        return "bg-darkred textColorWhite";
      }else if (this.TaskDetailsDropDown.taskStatus == 10414) {
        return "bg-forReview textColorWhite";
      } else {
        return "";
      }
    },
    async onTaskStatusChange(event: any) {
      const status = event && typeof event === 'object' && 'value' in event
        ? event.value
        : (event ?? this.TaskDetailsDropDown.taskStatus);
      await this.updateTaskStatus(status);
    },
    async updateTaskStatus(status: any) {
      const statusCode = status && typeof status === 'object' && 'value' in status
        ? status.value
        : status;
      let payload: any = { statusCode: statusCode };
      if(payload.statusCode==10414 &&(!this.presentFindingTaskObj.files || this.presentFindingTaskObj.files.length==0)){
        this.$nextTick(() => {
						this.TaskDetailsDropDown.taskStatus = this.presentFindingTaskObj.statusCode;
					});
         toast.error(`Please attach the Evidence`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: 'button',
              icon: true
            });
      }
      else {
        await this.updateFindingTask(4, payload);
      }           
    },
    async updateAssignedMember(obj: any) {
      let payload: any = { assignee: obj.value };
      await this.updateFindingTask(6, payload);
      if(this.presentFindingTaskObj.assignee != undefined ){
        this.newAssignee = this.presentFindingTaskObj.assignee
      }
    },
    handleInput() {
      this.btnDisabled = this.comment.length === 0;
    },
    async addComment() {
      if (this.comment.trim() !== "") {
        const newComment: any = {
          comment: this.comment,
        };
        await this.updateFindingTask(1, newComment);
        // if (this.presentFindingTaskObj.comments != undefined) {
        //   this.presentFindingTaskObj.comments.sort().reverse();
        // }
        // this.comments.push(newComment);
        this.comment = "";
        this.btnDisabled = true;
      }
    },
    clearComment() {
      this.comment = "";
      this.btnDisabled = true;
    },
    async toggleTabs(obj: any) {
      // { displayName: 'Description', id: 1 },

      // 	{ displayName: 'Related Documents', id: 2 },

      // 	{ displayName: 'Evidence', id: 3 },

      // 	{ displayName: 'Comments', id: 4 },

      // 	{ displayName: 'Approvals', id: 5 },

      // 	{ displayName: 'Work History', id: 6 }
      // ],
      // this.scrollTabIntoView(obj.id);
      // this.selectedTabIndex = obj.id;
      // this.selectedTabObj = obj;
      this.selectedTabIndex = obj.id;
      this.selectedTabObj = obj;
      //sessionStorage.setItem('selectedTab', obj.id);
      await this.getAllFindingTasks()
      await this.getFindingTaskHistoryObject()
     
    },
    showFindingPopup() {
      this.showPopUp = !this.showPopUp;
    },
    onCancelButtonAddPopUp() {
      this.showPopUp = false;
      this.onCancelbtn();
    },
    openFilePopup(mode: string = 'file') {
      this.evidenceAttachMode = mode === 'url' ? 'url' : 'file';
      this.evidenceUrl = '';
      this.v$.$reset();
      this.pdfValidation = false;
      this.inputFileName = '';
      this.fileToUpload = '';
      this.fileName = '';
      this.evidenceDate = '';
      this.importpopUp = true;
    },
    isEvidenceAttachDisabled() {
      return this.TaskDetailsDropDown.taskStatus == 10403 ||
        this.TaskDetailsDropDown.taskStatus == 10417 ||
        this.presentComplianceObject.statusCode == 10403 ||
        this.TaskDetailsDropDown.taskStatus == 10418 ||
        this.presentComplianceObject.statusCode == 10418 ||
        (this.presentFindingTaskObj.reviewer == this.userInfo._id && (this.userInfo?.role_id == 10215 && this.userInfo?.roleId == 10215)) ||
        !this.isAddDisabled(10302);
    },
    isPlannerCreatedEvidence(doc: any) {
      return doc?.taskId != null && String(doc.taskId) !== '' && String(doc.taskId) !== String(this.presentFindingTaskObj?.taskId ?? '');
    },
    openDeleteEvidenceConfirm(evidenceIndex: number) {
      if (evidenceIndex < 0) return;
      this.deleteEvidenceIndex = evidenceIndex;
      this.showDeleteEvidenceConfirm = true;
    },
    cancelDeleteEvidence() {
      this.showDeleteEvidenceConfirm = false;
      this.deleteEvidenceIndex = null;
    },
    async confirmDeleteEvidence() {
      const evidenceIndex = this.deleteEvidenceIndex;
      this.showDeleteEvidenceConfirm = false;
      this.deleteEvidenceIndex = null;
      if (evidenceIndex == null) return;
      await this.removeEvidence(evidenceIndex);
    },
    async removeEvidence(evidenceIndex: number) {
      if (this.isEvidenceAttachDisabled()) return;
      const evidence = this.presentFindingTaskObj?.files?.[evidenceIndex];
      if (this.isPlannerCreatedEvidence(evidence)) return;
      const url = evidence?.url;
      const isUrlEvidence = evidence?.evidenceType === 'url';
      try {
        let urlStillUsed = false;
        if (!isUrlEvidence && url) {
          const tasksResponse = await this.$http.get(`${process.env.VUE_APP_MONITOR_API}/capa/tasks`);
          const tasks = Array.isArray(tasksResponse?.data) ? tasksResponse.data : [];
          const currentId = String(this.currentTaskId || '');
          urlStillUsed = tasks.some((task: any) => String(task?._id || '') !== currentId && Array.isArray(task?.files) && task.files.some((doc: any) => doc?.url === url));
        }
        if (!isUrlEvidence && url && !urlStillUsed) {
          const fileResponse = await this.$http.post(`${process.env.VUE_APP_FILE_API}/bucket/file/delete`, { url });
          if (!(fileResponse.status == 200 && fileResponse.data?.deleted === true)) {
            return;
          }
        }
        await this.$http.post(
          `${process.env.VUE_APP_MONITOR_API}/capa/task/${this.currentTaskId}/evidence/remove`,
          { evidenceIndex, createdBy: this.userInfo._id }
        );
        await this.getAllFindingTasks();
        await this.getFindingTaskHistoryObject();
      } catch (err) {
        toast.error(`Failed to remove evidence`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: 'button',
          icon: true
        });
      }
    },
    async loadExistingFileOptions() {
      try {
        const [taskRes, capaRes, plannerRes] = await Promise.all([
          this.$http.get(`${process.env.VUE_APP_MONITOR_API}/api/org/tasks/getall`),
          this.$http.get(`${process.env.VUE_APP_MONITOR_API}/capa/tasks`),
          this.$http.get(`${process.env.VUE_APP_PLANNER_API}/api/org/tasks/getAll`),
        ]);
        const crTasks = (Array.isArray(taskRes?.data) ? taskRes.data : []).filter((task: any) => task?.actionType == 20501);
        const capaTasks = Array.isArray(capaRes?.data) ? capaRes.data : [];
        const plannerTasks = (Array.isArray(plannerRes?.data) ? plannerRes.data : []).map((task: any) => ({
          ...task,
          files: Array.isArray(task?.evidences) ? task.evidences : [],
        }));
        this.linkEvidenceTasks = crTasks.concat(capaTasks, plannerTasks);
      } catch (error) {
        this.linkEvidenceTasks = [];
        toast.error(`Failed to load tasks`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: 'button',
          icon: true
        });
      }
    },
    resetExistingEvidenceTable() {
      this.existingEvidenceSortKey = '';
      this.existingEvidenceSortDir = 'asc';
      this.showExistingEvidenceFilters = false;
      this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
    },
    toggleExistingEvidenceFilters() {
      this.showExistingEvidenceFilters = !this.showExistingEvidenceFilters;
      if (!this.showExistingEvidenceFilters) {
        this.existingEvidenceFilters = { filename: '', sourceTaskId: '', evidenceType: '', evidenceDate: '' };
      }
    },
    existingEvidenceTypeLabel(row: any) {
      if (row?.evidenceType === 'url') return String(row.evidenceType).toUpperCase();
      const readExt = (value: any) => {
        const text = String(value || '').split('?')[0];
        const ext = (text.split('.').pop() || '').toLowerCase();
        if (!ext || ext === text.toLowerCase()) return '';
        return ext;
      };
      const ext = readExt(row?.url) || readExt(row?.filename || row?.name);
      return ext ? ext.toUpperCase() : 'File';
    },
    sortExistingEvidence(key: string) {
      if (this.existingEvidenceSortKey === key) {
        this.existingEvidenceSortDir = this.existingEvidenceSortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.existingEvidenceSortKey = key;
        this.existingEvidenceSortDir = 'asc';
      }
    },
    openLinkEvidencePopup() {
      this.selectedExistingEvidences = [];
      this.resetExistingEvidenceTable();
      this.linkEvidencePopup = true;
      this.loadExistingFileOptions();
    },
    closeLinkEvidencePopup() {
      this.linkEvidencePopup = false;
      this.selectedExistingEvidences = [];
    },
    isExistingEvidenceSelected(row: any) {
      return (this.selectedExistingEvidences || []).some((item: any) => item.optionKey === row.optionKey);
    },
    toggleExistingEvidence(row: any) {
      const selected = [...(this.selectedExistingEvidences || [])];
      const index = selected.findIndex((item: any) => item.optionKey === row.optionKey);
      if (index >= 0) {
        selected.splice(index, 1);
      } else {
        selected.push(row);
      }
      this.selectedExistingEvidences = selected;
    },
    async saveLinkedEvidence() {
      const docs = this.selectedExistingEvidences || [];
      const files = docs.filter((doc: any) => doc?.url).map((doc: any) => {
        const filename = doc.filename || doc.name;
        const item: any = {
          url: doc.url,
          filename,
          evidenceDate: doc.evidenceDate,
          evidenceType: doc.evidenceType || 'file'
        };
        if (doc.name) {
          item.name = doc.name;
        }
        if (doc.fileType !== undefined && doc.fileType !== null) {
          item.fileType = doc.fileType;
        }
        if (doc.sourceTaskId != null && String(doc.sourceTaskId) !== '') {
          item.linkedEvidenceTaskId = String(doc.sourceTaskId);
        }
        return item;
      });
      if (!files.length) return;
      this.linkEvidencePopup = false;
      this.selectedExistingEvidences = [];
      await this.updateFindingTask(3, { files });
    },
    async handleUrlEvidenceSave() {
      this.v$.inputFileName.$touch();
      this.v$.evidenceUrl.$touch();
      this.v$.evidenceDate.$touch();
      if (this.v$.inputFileName.$invalid || this.v$.evidenceUrl.$invalid || this.v$.evidenceDate.$invalid) {
        return;
      }
      this.clickOnButtonAtAddingFile = true;
      this.importpopUp = false;
      try {
        const payload: any = {
          url: this.evidenceUrl,
          filename: this.inputFileName,
          evidenceDate: new Date(this.evidenceDate).toISOString(),
          evidenceType: 'url'
        };
        await this.updateFindingTask(3, payload);
        this.resetEvidenceForm();
      } catch (err) {
        console.error(err);
        toast.error(`Error`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: 'button',
          icon: true
        });
        this.resetEvidenceForm();
      } finally {
        this.clickOnButtonAtAddingFile = false;
      }
    },
    async handleFileChange(event: any) {
      if (this.evidenceAttachMode === 'url') {
        await this.handleUrlEvidenceSave();
        return;
      }
      let data = this.fileToUpload;
      this.v$.inputFileName.$touch()
      this.v$.fileToUpload.$touch();
      this.v$.evidenceDate.$touch()
      if (((!this.v$.fileToUpload.$invalid) && (!this.v$.inputFileName.$invalid) && (!this.v$.evidenceDate.$invalid) && !this.pdfValidation)) {
        this.clickOnButtonAtAddingFile = true;
        let fileExtension = data.name.split(".").pop();
          this.importpopUp = !this.importpopUp;
          const fileDataFormat = await this.getConvertDataForFile(data);
          let uuid = uuidv4();
          let payload = {
            fileData: fileDataFormat,
            name: `${uuid}.${fileExtension}`,
            fileType:1,
          };
          let folderName = `${process.env.VUE_APP_MONITOR_FOLDER_NAME}`;
          try {
            await this.$http
              .post(
                `${process.env.VUE_APP_FILE_API}/bucket/${folderName}/file/upload`,
                payload
              )
              .then(async (response: any) => {
                if (response.status == 200) {
                  let payload: any = {
                    name: `${uuid}.${fileExtension}`,
                    url: response.data,
                    filename: this.inputFileName,
                    evidenceDate:new Date(this.evidenceDate).toISOString(),
                    fileType:1,
                    evidenceType: 'file'
                  };
                  await this.updateFindingTask(3, payload);
                  this.resetEvidenceForm();
                }
              });
          } catch (err) {
            console.error(err);
          } finally {
            this.clickOnButtonAtAddingFile = false;
          }
      }
    },
    getS3KeyFromUrl(fileUrl: string) {
      try {
        const url = new URL(fileUrl);
        return url.pathname.startsWith('/')
          ? url.pathname.slice(1)
          : url.pathname;
      } catch (e) {
        return '';
      }
    },


    async openEvidenceFile(doc: any) {
      const fileUrl = typeof doc === 'string' ? doc : doc?.url;
      if (!fileUrl) return;

      if (typeof doc !== 'string' && doc?.evidenceType === 'url') {
        window.open(fileUrl, '_blank', 'noopener,noreferrer');
        return;
      }

      const key = this.getS3KeyFromUrl(fileUrl);
      if (!key) {
        return;
      }

      try {
        const response = await this.$http.post(
        `${process.env.VUE_APP_FILE_API}/presignedurl/v3`,
        { key }
        );

        const signedUrl =
        typeof response.data === 'string'
          ? response.data
          : response.data?.url;

        if (signedUrl) {
        window.open(signedUrl,'_Self', 'noopener,noreferrer');
        }
      } catch (err) {
        console.error(err);
      }
    },
    async updateFindingTask(type: any, payload: any) {
      payload.createdBy = this.userInfo._id;
      payload.createdAt = moment().format("YYYY-MM-DD HH:mm:ss");
      if(this.presentFindingTaskObj!=undefined && this.presentFindingTaskObj.statusCode && this.presentFindingTaskObj.statusCode==payload.statusCode){
      return;
    }
      if (type == 1) {
		// comment
        payload.additionalInfo = { comment: "" };
        payload.additionalInfo.comment = payload.comment;
        payload.updatedBy = this.userInfo._id;
        payload.updatedAt = moment().format("YYYY-MM-DD HH:mm:ss");
      } else if (type == 3) {
        if (Array.isArray(payload.files)) {
          payload.files.forEach((item: any) => {
            item.createdBy = payload.createdBy;
            item.taskId = this.presentFindingTaskObj?.taskId;
          });
        } else {
		// files
        payload.taskId = this.presentFindingTaskObj?.taskId
        payload.additionalInfo = { evidence: "" ,evidenceDate:""};
        payload.additionalInfo.evidence = payload.filename;
        payload.additionalInfo.evidenceDate=payload.evidenceDate,
        payload.fileType=payload.fileType
        }
      } else if (type == 4) {
		// statusCode
        payload.additionalInfo = { previousStatus: "", updatedStatus: "" };
        payload.additionalInfo.previousStatus = this.presentFindingTaskObj.statusCode;
        this.previousStatus = this.presentFindingTaskObj.statusCode;
        payload.additionalInfo.updatedStatus = payload.statusCode;
          if (payload.statusCode==10401 && this.TaskDetailsDropDown.taskStatus==10401) this.disabledStatuses = [];
          else if (payload.statusCode==10402) this.disabledStatuses = [];
          else if (payload.statusCode==10408) this.disabledStatuses = [];
          else if(payload.statusCode == 10414 ) this.disabledStatuses = [];
          else if(payload.statusCode == 10421) this.disabledStatuses = [];
          else if(payload.statusCode == 10403) this.disabledStatuses = []
          else this.disabledStatuses = [];
      } else if (type == 6) {
		// assignee
        payload.additionalInfo = { assignee: "" };
        payload.additionalInfo.assignee = payload.assignee;
      } else if (type == 8) {
		// approver
		payload.createdBy = this.userInfo._id;
      	payload.createdAt = moment().format("YYYY-MM-DD HH:mm:ss");
		// payload.approver = payload.approver;
        // payload.comments = payload.comments;
      }
      try {
        await this.$http
          .post(
            `${process.env.VUE_APP_MONITOR_API}/capa/task/${this.currentTaskId}/type/${type}/update`,
            payload
          )
          .then(async (result: any) => {
            toast.info(`Updated`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: "button",
              icon: true,
            });
            await this.getAllFindingTasks();
            await this.getFindingTaskHistoryObject();
            this.v$.$reset();
            this.taskObj = {approver:'',approvalComments:''};
          });
      } catch(e:any){
        if(e.response.status==403){
              toast.error(`${e.response.data.error}`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: 'button',
              icon: true
            });
          }
          else {
            toast.error('Error', {
            timeout: 1000,
            closeOnClick: true,
            closeButton: 'button',
            icon: true
          });
          }
      }finally {
				this.clickOnButton = false;
			}
    },
    isOptionDisabled(option:any) {
      return this.disabledStatuses.includes(option.id);
    },
    async getConvertDataForFile(data: any) {
      return new Promise((resolve) => {
        const reader: any = new FileReader();
        reader.onload = function () {
          // resolve(reader.result.replace("data:", "").replace(/^.+,/, ""));
          resolve(reader.result);
        };
        reader.readAsDataURL(data);
      });
    },
    colorAuditText(status: any) {
      if (status == 10401) {
        return ["font-semibold text-disabledgrey"];
      } else if (status == 10421) {
        return ["font-semibold text-yellow"];
      } else if (status == 10403) {
        return ["font-semibold text-lightgreen"];
      } else if (status == 10402) {
        return ["font-semibold mx-2 text-electricGreen"];
      } else if (status == 10408) {
        return ["font-semibold mx-2 text-primary"];
      } else if (status == 10417) {
        return ["font-semibold mx-2 text-darkred"];
      }
    },
    colorAuditBg(status: any) {
      if (status == 10401) {
        return ["bgDisabledGrey border-solid border border-disabledgrey"];
      } else if (status == 10421) {
        return ["bgYellow border-solid border border-yellow"];
      } else if (status == 10403) {
        return ["bgLightGreen border-solid border border-lightgreen"];
      } else if (status == 10402) {
        return ["bgElectricGreen border-solid border border-electricGreen"];
      } else if (status == 10408) {
        return ["bgPrimary border-solid border border-primary"];
      } else if (status == 10417) {
        return ["bgdarkred border-solid border border-darkred"];
      }
    },
    async getAllFindingTasks() {
      this.showLoader = true;
      this.tabDataLoading = true
      await this.$http
        .get(`${process.env.VUE_APP_MONITOR_API}/capa/task/${this.currentTaskId}`)
        .then((result: any) => {
          const taskList = Array.isArray(result.data) ? result.data : (result.data ? [result.data] : []);
          this.allTasks = taskList;
          this.showLoader = false;
          this.presentFindingTaskObj = taskList[0] || null;
          if (!this.presentFindingTaskObj) {
            this.approvalObj = {};
            return;
          }
          this.riskInformationArray = this.presentFindingTaskObj;
          this.TaskDetailsDropDown.taskStatus =this.presentFindingTaskObj.statusCode;
            if (this.presentFindingTaskObj.assignee != undefined || this.presentFindingTaskObj.assignee != null ) {
            let userObj: any = this.optionsUserArray.find((obj: any) => {
              return obj.value == this.presentFindingTaskObj.assignee;
            });
            this.presentFindingTaskObj.assignee = userObj;
          } else {
            let userObj: any = this.optionsUserArray.find((obj: any) => {
              return obj.value == this.presentFindingTaskObj.teamOwner;
            });
            this.presentFindingTaskObj.assignee = userObj;
          }
          if (this.presentFindingTaskObj.comments != undefined && this.presentFindingTaskObj.comments.length != 0) {
            let commentsArray: any = [];
              this.presentFindingTaskObj.comments.forEach((commentObj: any)=>{                
                commentObj.comment = commentObj.comment
                commentsArray.push(commentObj);
              })
              this.presentFindingTaskObj.comments = commentsArray
            
            // this.presentFindingTaskObj.comments.sort().reverse();
          }
          if (
            this.presentFindingTaskObj.approvals != null ||
            this.presentFindingTaskObj.approvals != undefined
          ) {
            const lastApproval =
              this.presentFindingTaskObj.approvals[
                this.presentFindingTaskObj.approvals.length - 1
              ];
            this.approvalObj = lastApproval;
          } else {
            this.approvalObj = {};
          }
          // console.log("this.presentFindingTaskObj", this.presentFindingTaskObj)
          // if (this.presentFindingTaskObj.location != 'Global') {
          //   let location
          //   if(this.allEntities != undefined || this.allEntities.length != 0){
          //     location = this.allEntities.find((loc: any)=>{
          //       return loc._id == this.presentFindingTaskObj.location
          //     })
          //   }
          //   // this.presentFindingTaskObj.location = location != undefined ? location.entityName : 'N/A'
          // } else if(this.presentFindingTaskObj.location == 'Global'){
          //   let location
          //   if(this.allEntities != undefined || this.allEntities.length != 0){
          //     location = this.allEntities.find((loc: any)=>{
          //       return loc.entityType == 1
          //     })
          //   }
          //   this.presentFindingTaskObj.location = location != undefined ? location.entityName : 'N/A'
          // }
        })
        .catch((error: any) => {
          console.error("Error fetching tasks:", error);
          this.showLoader = false
        });
        this.tabDataLoading = false
    },
  },
  async mounted(){
        emitter.off('addedComments');
        emitter.on('addedComments',(data: any)=>{
            this.comment = data.comments
            this.addComment()
        })
        window.addEventListener('resize', this.clampLinkWidthsToContainer);
    },
  beforeUnmount() {
     this.stopLinkColumnResize();
     window.removeEventListener('resize', this.clampLinkWidthsToContainer);
		 sessionStorage.removeItem('selectedTab')
	 },
  async created() {
    this.showLoader = true;
     const savedTabKey = sessionStorage.getItem('selectedTab');
		  if (savedTabKey) {
        const savedTab = this.tabHead.find((tab: any) => tab.id == savedTabKey);
        if (savedTab) {
			      this.toggleTabs(savedTab);
        }
   		else{
         this.selectedTabObj = { displayName: "Description", id: 1 };
	  	}
    }
    else{
	   this.selectedTabObj = { displayName: "Description", id: 1 };
	 }
   this.tabDataLoading = true
   await this.getCapaStatuses();
    await this.getallUsers();
    await this.getAllTeams();
    await this.getallEntities();
    await this.getPresentFindingObject()
    await this.getAllFindingTasks();
    this.tabDataLoading = false
    await this.getFindingTaskHistoryObject();
    // let taskId:any = this.currentTaskId;
    // let obj : any = this.presentFindingTaskObj.find((task: any)=>{return task._id == taskId})
    // this.presentFindingTaskObj = obj
    // this.selectedTabIndex = 1;
    this.findingsObjectDummy = { ...this.findingsObject };
    this.routesArray = [
      { name: "CAPA Tasks", routeName: "findingTasks" },
      { name: this.presentFindingTaskObj.taskId, routeName: "actionTask" },
    ];
    this.navIndexNums = { index: 1, name: "Description" };
    if(this.presentFindingTaskObj.assignee != undefined ){
      this.newAssignee = this.presentFindingTaskObj.assignee
    }
    if (this.presentFindingTaskObj.statusCode==10401) this.disabledStatuses = [];
      else if (this.presentFindingTaskObj.statusCode==10402) this.disabledStatuses = [];
      else if (this.presentFindingTaskObj.statusCode==10408) this.disabledStatuses = [];
      else if(this.presentFindingTaskObj.statusCode == 10414 ) this.disabledStatuses = [];
      else if(this.presentFindingTaskObj.statusCode == 10421) this.disabledStatuses = [];
      else if(this.presentFindingTaskObj.statusCode == 10403) this.disabledStatuses = []
      else this.disabledStatuses = [];
  },
});
</script>